(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-philosophy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-about-philosophy]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.about-item'));
      var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-phil-img]'));
      var list = root.querySelector('.about-philosophy__list');
      function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }
      function showImg(i) {
        imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-phil-img') === String(i)); });
      }
      function activeIndex() {
        var idx = '0';
        items.forEach(function (it) {
          var h = it.querySelector('[data-phil-select]');
          if (h && it.classList.contains('is-active')) idx = h.getAttribute('data-phil-select');
        });
        return idx;
      }
      root.querySelectorAll('[data-phil-select]').forEach(function (head) {
        var i = head.getAttribute('data-phil-select');
        head.addEventListener('click', function () {
          /* Desktop-only interaction — no click behaviour on mobile. */
          if (!isDesktop()) return;
          items.forEach(function (it) {
            var on = it.contains(head);
            it.classList.toggle('is-active', on);
            var h = it.querySelector('[data-phil-select]');
            if (h) h.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          showImg(i);
        });
        /* Hover preview: swap to this item's image while hovering. */
        head.addEventListener('mouseenter', function () {
          if (!isDesktop()) return;
          showImg(i);
        });
      });
      /* Leaving the list reverts the image to the selected (clicked) item. */
      if (list) {
        list.addEventListener('mouseleave', function () {
          if (!isDesktop()) return;
          showImg(activeIndex());
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.HinokCartLineGroups = factory();
})(globalThis, function createHinokCartLineGroups() {
  function members(row) {
    return row.dataset.lineGroup ? JSON.parse(row.dataset.lineGroup) : [
      { key: row.dataset.key, quantity: Number(row.dataset.quantity) }
    ];
  }
  function quantities(lines, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('Invalid cart quantity');
    var total = lines.reduce(function (sum, line) { return sum + line.quantity; }, 0);
    var remaining = Math.max(0, total - quantity);
    return lines.reduce(function (updates, line, index) {
      var removed = Math.min(line.quantity, remaining);
      updates[line.key] = line.quantity - removed + (index === 0 ? Math.max(0, quantity - total) : 0);
      remaining -= removed;
      return updates;
    }, {});
  }
  function formUpdates(form) {
    return Array.from(form.querySelectorAll('[name="updates[]"]')).reduce(function (updates, input) {
      var row = input.closest('[data-key]');
      return Object.assign(updates, quantities(members(row), Number(input.value)));
    }, {});
  }
  function render(root) {
    Array.from(root.querySelectorAll('.cart-drawer__items, .cart-page__list')).forEach(function (list) {
      var groups = new Map();
      Array.from(list.children).forEach(function (row) {
        if (!row.dataset.key) return;
        var identity = row.dataset.lineGroupId || row.dataset.key;
        if (!groups.has(identity)) groups.set(identity, []);
        groups.get(identity).push(row);
      });
      groups.forEach(function (rows) {
        if (rows.length < 2) return;
        var first = rows[0];
        var lines = rows.reduce(function (all, row) { return all.concat(members(row)); }, []);
        var quantity = lines.reduce(function (sum, line) { return sum + line.quantity; }, 0);
        var total = rows.reduce(function (sum, row) { return sum + Number(row.dataset.lineTotal); }, 0);
        first.dataset.lineGroup = JSON.stringify(lines);
        first.dataset.quantity = String(quantity);
        first.dataset.lineTotal = String(total);
        var count = first.querySelector('.cart-item__qty-num');
        if (count) count.textContent = String(quantity);
        var input = first.querySelector('[name="updates[]"]');
        if (input) { input.value = String(quantity); input.defaultValue = String(quantity); }
        var price = first.querySelector('.cart-item__price, .cart-page__price');
        if (price) price.textContent = new Intl.NumberFormat(root.documentElement?.lang || document.documentElement.lang || 'en-US', {
          style: 'currency', currency: first.dataset.lineCurrency || 'USD'
        }).format(total / 100);
        rows.slice(1).forEach(function (row) { row.remove(); });
      });
    });
  }
  function change(row, quantity, routes, request) {
    var lines = members(row);
    var updates = quantities(lines, quantity);
    var changed = lines.filter(function (line) { return updates[line.key] !== line.quantity; });
    if (!changed.length) return Promise.resolve();
    if (changed.length === 1) return request(routes.change, { id: changed[0].key, quantity: updates[changed[0].key] });
    return request(routes.update, { updates: updates });
  }
  return { members: members, quantities: quantities, formUpdates: formUpdates, render: render, change: change };
});

/* BEGIN hinok email snapshot helpers */
/* Candidate only. No listeners or requests are installed by loading this file. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.createHinokCartSnapshotCapture = factory;
})(globalThis, function createHinokCartSnapshotCapture(options, env) {
  'use strict';
  options = options || {};
  env = env || globalThis;
  var METRIC = 'Hinok Added to Cart Snapshot';
  var revision = 0;
  var lastSentSignature = null;
  var pendingSignature = null;
  var allowedReasons = ['paid_add', 'paid_change'];
  var origin = new URL(options.origin || env.location.origin).origin;
  if (origin.indexOf('https://') !== 0) throw new Error('HTTPS storefront required');
  if (typeof options.isSettledCart !== 'function' || typeof options.isGiftLine !== 'function') {
    throw new Error('Verified cart and managed-gift predicates are required');
  }

  function requireInt(value, name, minimum) {
    if (!Number.isSafeInteger(value) || value < minimum) throw new Error('Invalid ' + name);
    return value;
  }
  function text(value, maximum) { return typeof value === 'string' ? value.slice(0, maximum) : ''; }
  function money(cents) { return requireInt(cents, 'money', 0) / 100; }
  function publicUrl(value, isProduct) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      var url = new URL(value, origin);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      if (isProduct && (url.origin !== origin || !/\/products\//.test(url.pathname))) return '';
      return url.href;
    } catch (_) { return ''; }
  }
  function productUrl(item) {
    return publicUrl(item.url || ('/products/' + encodeURIComponent(item.handle || '')), true);
  }
  function imageUrl(item) {
    return publicUrl(item.featured_image && item.featured_image.url || item.image || '', false);
  }
  function row(item, isGift, parent) {
    var quantity = requireInt(item.quantity, 'quantity', 1);
    var finalLine = requireInt(item.final_line_price, 'final line price', 0);
    if (isGift && finalLine !== 0) throw new Error('Gift price has not settled');
    var title = text(item.product_title || item.title, 300);
    if (!title) throw new Error('Missing product title');
    var result = {
      product_id: String(requireInt(Number(item.product_id), 'product ID', 1)),
      variant_id: String(requireInt(Number(item.variant_id || item.id), 'variant ID', 1)),
      title: title,
      variant_title: text(item.variant_title, 180),
      quantity: quantity,
      image_url: imageUrl(item),
      product_url: productUrl(item),
      original_unit_price: money(item.original_price),
      final_unit_price: money(item.final_price),
      original_line_price: money(item.original_line_price),
      final_line_price: money(finalLine),
      is_gift: Boolean(isGift),
      is_complimentary: Boolean(isGift && finalLine === 0),
      gift_evidence: isGift ? (parent ? 'managed_parent_and_component_zero' : 'managed_line_zero') : ''
    };
    if (parent) result.parent_variant_id = String(parent.variant_id || parent.id);
    return result;
  }
  function giftComponentRow(component, parent) {
    // Component identity, quantity and image must come from the actual bundle.
    // Missing allocations may use the verified zero-priced managed parent;
    // an explicitly charged component is never relabelled as complimentary.
    var derived = component.final_line_price == null || component.final_price == null;
    if ((component.final_line_price != null && component.final_line_price !== 0)
        || (component.final_price != null && component.final_price !== 0)) throw new Error('Charged component allocation');
    var child = row(Object.assign({}, component, {
      final_line_price: component.final_line_price == null ? 0 : component.final_line_price,
      final_price: component.final_price == null ? 0 : component.final_price,
      original_price: component.original_price == null ? 0 : component.original_price,
      original_line_price: component.original_line_price == null ? 0 : component.original_line_price
    }), true, parent);
    if (!child.image_url) throw new Error('Missing component image');
    if (component.original_price == null) child.original_unit_price = null;
    if (component.original_line_price == null) child.original_line_price = null;
    if (derived) child.gift_evidence = 'managed_bundle_parent_zero';
    return child;
  }
  function hasProperties(item) {
    var mailMetadata = ['_hinok_mail_final_line_price', '_hinok_mail_quantity', '_hinok_mail_is_gift',
      '_hinok_mail_snapshot_version', '_hinok_mail_snapshot_at', '_hinok_mail_snapshot_id'];
    return Object.keys(item.properties || {}).some(function (key) {
      return mailMetadata.indexOf(key) === -1 && item.properties[key] !== null && item.properties[key] !== '';
    });
  }
  function build(cart, reason) {
    if (allowedReasons.indexOf(reason) === -1) throw new Error('Not a paid cart mutation');
    if (!cart || !Array.isArray(cart.items) || cart.currency !== 'USD') throw new Error('Unsupported cart');
    if (!options.isSettledCart(cart)) throw new Error('Cart is not verified and settled');
    requireInt(cart.total_price, 'cart total', 0);
    var displayRows = [];
    var paidRows = [];
    var finalLineTotal = 0;
    cart.items.forEach(function (item) {
      var isGift = options.isGiftLine(item) === true;
      if (item.properties && item.properties._hinok_gwp && !isGift) throw new Error('Unrecognized managed gift');
      var normalized = row(item, isGift);
      finalLineTotal += item.final_line_price;
      if (!isGift) {
        // Variant-only permalinks cannot faithfully reconstruct these lines.
        // Do not drop their properties or send a falsely matching recovery link.
        if (hasProperties(item) || item.selling_plan_allocation || item.selling_plan) {
          throw new Error('Cart recovery cannot preserve line customization or selling plan');
        }
        paidRows.push(normalized);
      }
      var components = item.item_components;
      var expanded = null;
      if (isGift && Array.isArray(components) && components.length) {
        try {
          expanded = components.map(function (component) {
            return giftComponentRow(component, item);
          });
        } catch (_) {
          // Keep the actual bundle when component identity/image evidence is
          // incomplete or an explicit child allocation conflicts with free.
          expanded = null;
        }
      }
      var hasChargedComponent = Array.isArray(components) && components.some(function (component) {
        return component.final_line_price > 0 || component.final_price > 0;
      });
      if (isGift && (!expanded || expanded.length !== 2) && !hasChargedComponent && item.quantity === 1
          && typeof options.resolveGiftComponents === 'function') {
        var catalog = options.resolveGiftComponents(item);
        if (catalog && String(catalog.parent_variant_id) === normalized.variant_id
            && catalog.parent_quantity === 1 && catalog.evidence === 'managed_parent_catalog_verified'
            && Array.isArray(catalog.components) && catalog.components.length === 2) {
          try {
            expanded = catalog.components.map(function (component) {
              if (component.quantity !== 1) throw new Error('Unsupported catalog bundle quantity');
              var child = giftComponentRow(component, item);
              child.gift_evidence = 'managed_parent_catalog_verified';
              return child;
            });
            if (expanded[0].variant_id === expanded[1].variant_id) expanded = null;
          } catch (_) { expanded = null; }
        }
      }
      displayRows = displayRows.concat(expanded || [normalized]);
    });
    if (displayRows.length > 50) throw new Error('Cart exceeds candidate row limit');
    if (cart.total_price > finalLineTotal) throw new Error('Inconsistent cart total');
    var paidQuantity = paidRows.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var discountCodes = typeof options.recoveryDiscountCodes === 'function' ? options.recoveryDiscountCodes(cart) : [];
    if (!Array.isArray(discountCodes) || discountCodes.some(function (code) {
      return typeof code !== 'string' || !code || code.indexOf(',') !== -1 || code.length > 100;
    })) throw new Error('Unsupported recovery discount');
    var counts = {};
    paidRows.forEach(function (item) { counts[item.variant_id] = (counts[item.variant_id] || 0) + item.quantity; });
    var rebuild = '';
    if (paidQuantity) {
      var parts = Object.keys(counts).sort().map(function (id) { return id + ':' + counts[id]; });
      var recovery = new URL('/cart/' + parts.join(','), origin);
      recovery.searchParams.set('storefront', 'true');
      if (discountCodes.length) recovery.searchParams.set('discount', discountCodes.join(','));
      rebuild = recovery.href;
      if (rebuild.length > 2000) throw new Error('Recovery URL too long');
    }
    return {
      CartSnapshotVersion: 1,
      CartSnapshotReady: Boolean(paidQuantity),
      SnapshotValid: Boolean(paidQuantity),
      SnapshotReason: reason,
      Currency: cart.currency,
      CartItems: paidQuantity ? displayRows : [],
      CartRebuildURL: rebuild,
      PaidItems: paidRows.map(function (item) { return { variant_id: item.variant_id, quantity: item.quantity }; }),
      PaidQuantity: paidQuantity,
      PaidItemCount: paidRows.length,
      PaidSubtotal: paidRows.reduce(function (sum, item) { return sum + item.final_line_price; }, 0),
      CartTotal: money(cart.total_price),
      CartDiscountTotal: money(finalLineTotal - cart.total_price),
      '$value': money(cart.total_price),
      RecoveryDiscountCodes: discountCodes
    };
  }
  function consentAllowed() {
    try {
      var privacy = env.Shopify && env.Shopify.customerPrivacy;
      return Boolean(privacy && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true);
    } catch (_) { return false; }
  }
  function noteMutation(reason) {
    if (allowedReasons.indexOf(reason) === -1) throw new Error('Unsupported mutation reason');
    return { revision: ++revision, reason: reason };
  }
  function current(ticket) { return ticket && ticket.revision === revision; }
  async function captureSettled(cart, ticket) {
    if (!current(ticket)) return { sent: false, reason: 'superseded_mutation' };
    if (!consentAllowed()) return { sent: false, reason: 'consent_unavailable_or_denied' };
    var sdk = env.klaviyo;
    if (!sdk || typeof sdk.isIdentified !== 'function' || typeof sdk.track !== 'function') {
      return { sent: false, reason: 'klaviyo_unavailable' };
    }
    var payload;
    try { payload = build(cart, ticket.reason); }
    catch (error) { return { sent: false, reason: 'unsupported_or_unsettled_cart', detail: error.message }; }
    // This in-page fingerprint excludes timestamp/ID. No cookies, cart token,
    // email, recipient properties, or local/session storage are inspected.
    var signature = JSON.stringify(payload);
    if (signature === lastSentSignature || signature === pendingSignature) return { sent: false, reason: 'duplicate_snapshot' };
    try {
      if (await sdk.isIdentified() !== true) return { sent: false, reason: 'anonymous' };
      if (!current(ticket) || !consentAllowed() || !options.isSettledCart(cart)) return { sent: false, reason: 'state_changed_before_track' };
      if (signature === lastSentSignature || signature === pendingSignature) return { sent: false, reason: 'duplicate_snapshot' };
      if (!env.crypto || typeof env.crypto.randomUUID !== 'function') return { sent: false, reason: 'snapshot_id_unavailable' };
      payload.SnapshotID = env.crypto.randomUUID();
      payload.$event_id = payload.SnapshotID;
      payload.SnapshotCreatedAt = new Date().toISOString();
      pendingSignature = signature;
      var accepted = await sdk.track(METRIC, payload);
      if (accepted === true) lastSentSignature = signature;
      return { sent: accepted === true, reason: accepted === true ? 'sdk_accepted' : 'sdk_not_accepted',
        persistence: 'unverified', snapshotID: payload.SnapshotID };
    } catch (_) { return { sent: false, reason: 'sdk_error' }; }
    finally { if (pendingSignature === signature) pendingSignature = null; }
  }
  return { metric: METRIC, noteMutation: noteMutation, captureSettled: captureSettled, build: build,
    invalidate: function () { ++revision; } };
});

(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.createHinokCartSnapshotRecheck = factory;
})(globalThis, function createHinokCartSnapshotRecheck(options, env) {
  'use strict';
  env = env || globalThis;
  var active = null;
  var timer = null;
  var expiry = null;
  var running = false;
  var listening = false;
  var delays = [500, 1500, 3000, 5000, 10000, 15000, 30000];
  var lifetime = options.lifetimeMs || 15 * 60 * 1000;
  var maxAttempts = options.maxAttempts || 48;
  var now = options.now || Date.now;
  var retryable = ['anonymous', 'consent_unavailable_or_denied', 'klaviyo_unavailable',
    'state_changed_before_track', 'identity_timeout', 'identity_error', 'cart_read_failed', 'cart_busy', 'page_hidden'];

  function note(result) {
    try { options.onResult(result); } catch (_) {}
  }
  function permission() {
    try {
      var p = env.Shopify && env.Shopify.customerPrivacy;
      return Boolean(p && p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true);
    } catch (_) { return false; }
  }
  function clearTimers() {
    if (timer !== null) env.clearTimeout(timer);
    if (expiry !== null) env.clearTimeout(expiry);
    timer = expiry = null;
  }
  function listen(enabled) {
    if (enabled === listening) return;
    listening = enabled;
    var method = enabled ? 'addEventListener' : 'removeEventListener';
    env.document[method]('visitorConsentCollected', wake);
    env.document[method]('visibilitychange', wake);
    env[method]('focus', wake);
    env[method]('pagehide', cancel);
  }
  function stop(invalidate) {
    var hadActive = Boolean(active);
    active = null;
    clearTimers();
    listen(false);
    if (invalidate && hadActive) options.capture.invalidate();
  }
  function cancel() { stop(true); }
  function current(job) {
    return active === job && now() < job.deadline;
  }
  function schedule(delay) {
    if (!active || !active.armed || running) return;
    if (timer !== null) env.clearTimeout(timer);
    timer = env.setTimeout(run, delay);
  }
  function wake() {
    if (!active || !active.armed || (env.document && env.document.hidden)) return;
    schedule(250);
  }
  function bounded(promise, milliseconds, reason) {
    return new Promise(function (resolve, reject) {
      var timeout = env.setTimeout(function () { reject(new Error(reason)); }, milliseconds);
      Promise.resolve(promise).then(function (value) {
        env.clearTimeout(timeout); resolve(value);
      }, function (error) {
        env.clearTimeout(timeout); reject(error);
      });
    });
  }
  async function attempt(job) {
    if (options.shouldStop()) { cancel(); return null; }
    if (env.document.hidden) return { sent: false, reason: 'page_hidden' };
    if (options.isBusy()) return { sent: false, reason: 'cart_busy' };
    if (!permission()) return { sent: false, reason: 'consent_unavailable_or_denied' };
    var sdk = env.klaviyo;
    if (!sdk || typeof sdk.isIdentified !== 'function' || typeof sdk.track !== 'function') {
      return { sent: false, reason: 'klaviyo_unavailable' };
    }
    var identified;
    try {
      identified = await bounded(sdk.isIdentified(), 2000, 'identity_timeout');
    } catch (error) {
      return { sent: false, reason: error.message === 'identity_timeout' ? 'identity_timeout' : 'identity_error' };
    }
    if (!current(job)) return null;
    if (identified !== true) return { sent: false, reason: 'anonymous' };
    if (options.shouldStop()) { cancel(); return null; }
    if (!permission()) return { sent: false, reason: 'consent_unavailable_or_denied' };
    if (options.isBusy()) return { sent: false, reason: 'cart_busy' };
    var cart;
    try { cart = await options.readCart(); }
    catch (_) { return { sent: false, reason: 'cart_read_failed' }; }
    if (!current(job)) return null;
    if (options.shouldStop()) { cancel(); return null; }
    if (options.isBusy()) return { sent: false, reason: 'cart_busy' };
    if (!permission()) return { sent: false, reason: 'consent_unavailable_or_denied' };
    try {
      return await bounded(options.capture.captureSettled(cart, job.ticket), 10000, 'capture_timeout');
    } catch (_) {
      if (current(job)) options.capture.invalidate();
      return { sent: false, reason: 'capture_timeout', persistence: 'unverified' };
    }
  }
  async function run() {
    timer = null;
    var job = active;
    if (!job || !job.armed || running) return;
    if (!current(job) || job.attempts >= maxAttempts) {
      note({ sent: false, reason: 'recheck_expired' }); cancel(); return;
    }
    running = true;
    job.attempts++;
    try {
      var result = await attempt(job);
      if (current(job) && result) {
        note(result);
        if (result.sent || retryable.indexOf(result.reason) === -1) stop(false);
      }
    } catch (_) {
      if (current(job)) {
        note({ sent: false, reason: 'recheck_error' });
        cancel();
      }
    } finally {
      running = false;
      if (active && active.armed) {
        if (active !== job) schedule(0);
        else schedule(delays[Math.min(job.attempts - 1, delays.length - 1)]);
      }
    }
  }
  function begin(ticket) {
    clearTimers();
    active = { ticket: ticket, deadline: now() + lifetime, attempts: 0, armed: false };
    listen(true);
    expiry = env.setTimeout(function () {
      note({ sent: false, reason: 'recheck_expired' }); cancel();
    }, lifetime);
  }
  function settled(ticket) {
    if (!active || active.ticket !== ticket) return;
    active.armed = true;
    schedule(0);
  }
  return { begin: begin, settled: settled, cancel: cancel };
});

(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.createHinokCheckoutMailStamp = factory;
})(globalThis, function createHinokCheckoutMailStamp(options, env) {
  'use strict';
  env = env || globalThis;
  var inFlight = null;
  var mode = 'bulk_variant_v1';
  var legacyFields = ['_hinok_mail_final_line_price', '_hinok_mail_quantity', '_hinok_mail_is_gift',
    '_hinok_mail_snapshot_version', '_hinok_mail_snapshot_at', '_hinok_mail_snapshot_id'];
  var retiredAttributes = ['_hinok_mail_snapshot_version', '_hinok_mail_snapshot_mode',
    '_hinok_mail_snapshot_at', '_hinok_mail_cart_total', '_hinok_mail_discount_codes'];
  ['readCart', 'updateAttributes', 'isCartValid', 'isGiftLine', 'discountCodes'].forEach(function (name) {
    if (typeof options[name] !== 'function') throw new Error('Missing checkout stamp adapter: ' + name);
  });
  function stable(value) {
    if (Array.isArray(value)) return value.map(stable);
    if (value && typeof value === 'object') return Object.keys(value).sort().reduce(function (copy, key) {
      copy[key] = stable(value[key]); return copy;
    }, {});
    return value;
  }
  function discountProof(cart) {
    if (!Number.isSafeInteger(cart.total_discount) || cart.total_discount < 0) throw new Error('invalid_discount_total');
    var codes = options.discountCodes(cart);
    if (!Array.isArray(codes) || codes.some(function (code) {
      return typeof code !== 'string' || !code || code.indexOf('|') !== -1;
    })) throw new Error('unsupported_discount_code');
    return { total: cart.total_discount, codes: Array.from(new Set(codes.map(function (code) {
      return code.toLowerCase();
    }))).sort().join('|') };
  }
  function state(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.currency !== 'USD'
        || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) throw new Error('unsupported_cart');
    var seen = new Set();
    var rows = cart.items.map(function (item) {
      var variant = Number(item.variant_id || item.id);
      if (!Number.isSafeInteger(variant) || variant < 1) throw new Error('invalid_variant');
      var role = options.isGiftLine(item) === true ? 'gift' : 'paid';
      if (seen.has(role + ':' + variant)) throw new Error('ambiguous_duplicate_role_variant');
      seen.add(role + ':' + variant);
      if (!Number.isSafeInteger(item.quantity) || item.quantity < 1 || !Number.isSafeInteger(item.final_price)
          || item.final_price < 0 || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) throw new Error('invalid_line_amount');
      var properties = Object.keys(item.properties || {}).filter(function (key) { return legacyFields.indexOf(key) === -1; })
        .reduce(function (copy, key) { copy[key] = item.properties[key]; return copy; }, {});
      return { variant: variant, role: role, product: item.product_id, quantity: item.quantity, final_price: item.final_price,
        final_line_price: item.final_line_price, is_gift: options.isGiftLine(item) === true,
        properties: stable(properties), selling_plan: stable(item.selling_plan_allocation || null) };
    }).sort(function (a, b) { return a.variant - b.variant || a.role.localeCompare(b.role); });
    return JSON.stringify({ currency: cart.currency, total_price: cart.total_price, discounts: discountProof(cart), rows: rows });
  }
  function prepare(seedCart) {
    if (inFlight) return inFlight;
    var controller = new env.AbortController();
    var timeoutMs = Math.min(5000, Math.max(100, Number(options.timeoutMs) || 4500));
    var started = Date.now(), timer;
    var mayHaveAttestation = Boolean(seedCart && seedCart.attributes && seedCart.attributes._hinok_mail_snapshot_id);
    var invalidationConfirmed = !mayHaveAttestation;
    function guard() {
      if (controller.signal.aborted || Date.now() - started >= timeoutMs) throw new Error('metadata_timeout');
      if (typeof options.isCurrent === 'function' && !options.isCurrent()) throw new Error('cart_operation_superseded');
    }
    async function step(fn) { guard(); var value = await fn(controller.signal); guard(); return value; }
    async function requireCart(value) {
      return value && Array.isArray(value.items) ? value : step(function (signal) { return options.readCart(signal); });
    }
    async function run() {
      if (!env.crypto || typeof env.crypto.randomUUID !== 'function') throw new Error('snapshot_id_unavailable');
      if (!seedCart || !seedCart.items || !seedCart.items.length || !options.isCartValid(seedCart)) throw new Error('gift_cart_not_verified');
      var baseline = state(seedCart), discounts = discountProof(seedCart);
      var snapshotID = env.crypto.randomUUID(), observedAt = new Date().toISOString();
      var attributes = {};
      Object.keys(seedCart.attributes || {}).forEach(function (key) {
        if (/^_hinok_mail_((paid|gift)_(price|qty)|price|qty|gift)_\d+$/.test(key)
            || retiredAttributes.indexOf(key) !== -1) attributes[key] = '';
      });
      seedCart.items.forEach(function (item) {
        var id = String(item.variant_id || item.id);
        var isGift = options.isGiftLine(item) === true;
        var prefix = '_hinok_mail_' + (isGift ? 'gift' : 'paid') + '_';
        attributes[prefix + 'qty_' + id] = String(item.quantity);
        if (isGift) attributes[prefix + 'price_' + id] = String(item.final_line_price);
      });
      Object.assign(attributes, { _hinok_mail_snapshot_id: snapshotID,
        _hinok_mail_discount_total: String(discounts.total) });
      // All evidence and its ID are one atomic cart-attribute update. No line
      // properties or quantities change, and no per-line requests are made.
      mayHaveAttestation = true; invalidationConfirmed = false;
      var cart = await requireCart(await step(function (signal) { return options.updateAttributes(attributes, signal); }));
      if (!options.isCartValid(cart) || state(cart) !== baseline || Object.keys(attributes).some(function (key) {
        return String(cart.attributes && cart.attributes[key] || '') !== attributes[key];
      })) throw new Error('attestation_readback_mismatch');
      return { ready: true, snapshotID: snapshotID, observedAt: observedAt, mode: mode, cart: cart };
    }
    var timeout = new Promise(function (resolve) {
      timer = env.setTimeout(function () {
        controller.abort();
        resolve({ ready: false, reason: 'metadata_timeout', invalidationConfirmed: invalidationConfirmed,
          attestationMayBePresent: mayHaveAttestation });
      }, timeoutMs);
    });
    var operation = run().catch(async function (error) {
      if (mayHaveAttestation && !controller.signal.aborted && Date.now() - started < timeoutMs - 100) {
        try {
          var cleared = await requireCart(await step(function (signal) {
            return options.updateAttributes({ _hinok_mail_snapshot_id: '' }, signal);
          }));
          invalidationConfirmed = !(cleared.attributes && cleared.attributes._hinok_mail_snapshot_id);
          mayHaveAttestation = !invalidationConfirmed;
        } catch (_) {}
      }
      return { ready: false, reason: error.message || 'metadata_error', invalidationConfirmed: invalidationConfirmed,
        attestationMayBePresent: mayHaveAttestation };
    });
    inFlight = Promise.race([operation, timeout]).finally(function () {
      env.clearTimeout(timer); controller.abort(); inFlight = null;
    });
    return inFlight;
  }
  return { prepare: prepare, state: state };
});

(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else root.installHinokCartPageMutations = factory;
})(globalThis, function installHinokCartPageMutations(options, env) {
  'use strict';
  env = env || globalThis;
  env.document.documentElement.classList.add('cart-page-ajax');
  var quantityTimer;
  var quantitySelector = '[data-cart-page-section] .cart-page__qty';
  function closest(target, selector) { return target && typeof target.closest === 'function' ? target.closest(selector) : null; }
  function cancelQuantityUpdate() {
    env.clearTimeout(quantityTimer);
    quantityTimer = null;
  }
  function quantityValid(input) {
    var value = Number(input.value);
    return input.value.trim() !== '' && Number.isSafeInteger(value) && value >= 0 && input.checkValidity();
  }
  function updateQuantities(form, trigger) {
    cancelQuantityUpdate();
    if (!form || !form.isConnected || options.isBusy()) return;
    var inputs = Array.from(form.querySelectorAll('.cart-page__qty'));
    if (!inputs.every(quantityValid)) return;
    var changed = inputs.filter(function (input) {
      return Number(input.value) !== Number(closest(input, '[data-key]').dataset.quantity);
    });
    if (!changed.length) return;
    var focused = trigger || env.document.activeElement;
    var focusedRow = closest(focused, '.cart-page__row');
    var focusKey = focusedRow && (focusedRow.dataset.lineGroupId || focusedRow.dataset.key);
    var focusIndex = focusedRow ? Array.from(form.querySelectorAll('.cart-page__row')).indexOf(focusedRow) : -1;
    var focusStep = focused && focused.getAttribute('data-cart-page-step');
    var operation;
    try {
      operation = changed.length === 1
        ? env.HinokCartLineGroups.change(closest(changed[0], '[data-key]'), Number(changed[0].value), options.routes, options.request)
        : options.request(options.routes.update, { updates: env.HinokCartLineGroups.formUpdates(form) });
    } catch (error) { operation = Promise.reject(error); }
    Promise.resolve(operation).catch(function (error) {
      var currentForm = env.document.querySelector('[data-cart-page-section] [data-gwp-checkout-form]');
      if (currentForm) Array.from(currentForm.querySelectorAll('.cart-page__qty')).forEach(function (input) {
        input.value = closest(input, '[data-key]').dataset.quantity;
      });
      options.onError(error, currentForm || form);
    }).finally(function () {
      if (!focusKey || (env.document.activeElement !== env.document.body && env.document.activeElement !== focused)) return;
      var rows = Array.from(env.document.querySelectorAll('[data-cart-page-section] .cart-page__row'));
      var row = rows.find(function (item) { return (item.dataset.lineGroupId || item.dataset.key) === focusKey; });
      if (!row) row = rows[Math.min(focusIndex, rows.length - 1)];
      var control = row && row.querySelector(focusStep ? '[data-cart-page-step="' + focusStep + '"]' : '.cart-page__qty');
      if (!control) control = env.document.querySelector('[data-cart-page-section] [data-gwp-checkout], .cart-page__continue');
      if (control) control.focus({ preventScroll: true });
    });
  }
  function scheduleQuantityUpdate(event) {
    var input = closest(event.target, quantitySelector);
    if (!input || event.defaultPrevented || options.isBusy()) return;
    cancelQuantityUpdate();
    if (!quantityValid(input)) return;
    var form = closest(input, '[data-gwp-checkout-form]');
    quantityTimer = env.setTimeout(function () { updateQuantities(form); }, 400);
  }
  env.document.addEventListener('input', scheduleQuantityUpdate);
  env.document.addEventListener('change', scheduleQuantityUpdate);
  env.document.addEventListener('click', function (event) {
    var step = closest(event.target, '[data-cart-page-section] [data-cart-page-step]');
    if (!step || event.defaultPrevented) return;
    event.preventDefault();
    if (options.isBusy()) return;
    var row = closest(step, '[data-key]');
    var input = row && row.querySelector('.cart-page__qty');
    if (!input) return;
    var quantity = quantityValid(input) ? Number(input.value) : Number(row.dataset.quantity);
    input.value = String(Math.max(0, quantity + Number(step.getAttribute('data-cart-page-step'))));
    updateQuantities(closest(step, '[data-gwp-checkout-form]'), step);
  });
  function send(url, payload, form) {
    Promise.resolve().then(function () { return options.request(url, payload); })
      .catch(function (error) { options.onError(error, form); });
  }
  env.document.addEventListener('submit', function (event) {
    var form = closest(event.target, '[data-cart-page-section] [data-gwp-checkout-form]');
    if (!form || event.defaultPrevented) return;
    cancelQuantityUpdate();
    if (event.submitter && event.submitter.name === 'checkout') return;
    if (event.submitter && !closest(event.submitter, '.cart-page__update')) return;
    var inputs = Array.from(form.querySelectorAll('[name="updates[]"]'));
    if (!inputs.length || (typeof form.checkValidity === 'function' && !form.checkValidity())) return;
    var updates = inputs.map(function (input) { return Number(input.value); });
    if (updates.some(function (quantity) { return !Number.isSafeInteger(quantity) || quantity < 0; })) return;
    event.preventDefault();
    if (options.isBusy()) return;
    updateQuantities(form);
  });
  env.document.addEventListener('click', function (event) {
    var link = closest(event.target, '[data-cart-page-section] .cart-page__remove');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
        || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    var url;
    try { url = new URL(link.href, env.location.href); } catch (_) { return; }
    var expected = new URL(options.routes.change, env.location.href);
    if (url.origin !== expected.origin || url.pathname.replace(/\.js$/, '') !== expected.pathname.replace(/\.js$/, '')
        || url.searchParams.get('quantity') !== '0') return;
    var payload = { quantity: 0 };
    if (url.searchParams.get('id')) payload.id = url.searchParams.get('id');
    else if (/^[1-9]\d*$/.test(url.searchParams.get('line') || '')) payload.line = Number(url.searchParams.get('line'));
    else return;
    event.preventDefault();
    if (options.isBusy()) return;
    var row = closest(link, '[data-key]');
    if (row) {
      Promise.resolve().then(function () {
        return env.HinokCartLineGroups.change(row, 0, options.routes, options.request);
      }).catch(function (error) { options.onError(error, closest(link, '[data-gwp-checkout-form]')); });
    } else send(options.routes.change, payload, closest(link, '[data-gwp-checkout-form]'));
  });
});

/* END hinok email snapshot helpers */
  /* Cart drawer — open/close, AJAX cart mutations, Section Rendering swaps.
     No Liquid in this block: routes/config come from data-* on #cart-drawer. */
  (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    window.HinokCartLineGroups.render(document);
    var routes = {
      add: drawer.getAttribute('data-route-add') + '.js',
      change: drawer.getAttribute('data-route-change') + '.js',
      update: drawer.getAttribute('data-route-update') + '.js',
      cart: drawer.getAttribute('data-route-cart') + '.js'
    };
    var gwp = {};
    var careUnavailableVariants = new Set();
    function readGwpConfig() {
      gwp.enabled = drawer.getAttribute('data-gwp-enabled') === 'true';
      gwp.threshold = parseInt(drawer.getAttribute('data-gwp-threshold'), 10) || 0;
      gwp.variant = parseInt(drawer.getAttribute('data-gwp-variant'), 10) || 0;
      gwp.available = drawer.getAttribute('data-gwp-available') === 'true';
      gwp.fallbackVariant = parseInt(drawer.getAttribute('data-gwp-fallback-variant'), 10) || 0;
      gwp.fallbackAvailable = drawer.getAttribute('data-gwp-fallback-available') === 'true';
      gwp.productHandle = drawer.getAttribute('data-gwp-product-handle') || '';
      gwp.fallbackHandle = drawer.getAttribute('data-gwp-fallback-product-handle') || '';
      gwp.discountCode = drawer.getAttribute('data-gwp-discount-code') || '';
      gwp.marker = drawer.getAttribute('data-gwp-marker') || 'to-go-70';
      gwp.tiered = drawer.dataset.gwpTiered === 'true';
      gwp.combinedCode = drawer.dataset.gwpCombinedDiscountCode || '';
      gwp.locale = drawer.dataset.gwpLocale || 'en-US';
      gwp.copy = {};
      ['away', 'included', 'pending', 'added', 'completed', 'empty', 'gift_unavailable', 'duplicate_direct', 'duplicate_set', 'duplicate_both', 'duplicate_named', 'unavailable', 'join'].forEach(function (key) {
        gwp.copy[key] = drawer.getAttribute('data-gwp-care-' + key) || '';
      });
      var giftOptions = [
        { variant: gwp.variant, available: gwp.available },
        { variant: gwp.fallbackVariant, available: gwp.fallbackAvailable }
      ];
      giftOptions.forEach(function (option) {
        option.available = Boolean(option.variant && option.available && !careUnavailableVariants.has(option.variant));
      });
      var giftVariant = careGifts.availableVariant(giftOptions);
      // Retain the old pair metadata for cart snapshots and gift-line cleanup.
      gwp.pairs = JSON.parse(drawer.dataset.gwpPairOptions || '[]');
      gwp.tiers = [
        { key: 'hand-balm', handle: 'the-hand-balm-35ml', variant: giftVariant, available: Boolean(giftVariant),
          threshold: gwp.threshold, code: gwp.discountCode, title: drawer.dataset.gwpCareGift || '' }
      ];
    }
    var careGifts = window.createHinokCareGiftPolicy(gwp);
    window.HinokCareGifting = careGifts;
    readGwpConfig();
    var careGiftError = false;
    var pendingCartMutations = 0;
    var pendingGiftSections = null;
    var pendingShippingRegion = null;
    var gwpCheckoutBlocked = false;
    var gwpErrorMessage = null;

    /* Whole-cart email evidence: optional CRM work must not block shopping. */
    var lastCartSnapshotResult = null;
    var lastCheckoutMailStampResult = null;
    var mailCartAttributes = {};
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
    function rememberMailCart(cart) {
      if (cart && cart.attributes) {
        mailCartAttributes = Object.assign({}, cart.attributes);
        drawer.dataset.mailSnapshotId = cart.attributes._hinok_mail_snapshot_id || '';
      }
      return cart;
    }
    function mailCartRequest(url, payload, signal) {
      var init = { method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: signal };
      if (payload) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(payload); }
      return fetch(url, init).then(parseCartResponse).then(rememberMailCart);
    }
    function mailGiftLine(item) { return careGifts.managed(item) && Boolean(careGifts.tierFor(item)); }
    var verifiedMailPairs = {"67614080401540":[50693552275588,51397070815364],"67614244274308":[50693552275588,51448817025156],"67614244339844":[50673077223556,51397070815364],"67614244503684":[50673077223556,51448817025156]};
    function resolveMailGiftComponents(item) {
      var tier = careGifts.tierFor(item);
      if (!mailGiftLine(item) || !tier || tier.key !== 'care-pair' || item.quantity !== 1 || item.final_line_price !== 0) return null;
      var parentID = Number(item.variant_id || item.id);
      var expected = verifiedMailPairs[String(parentID)];
      var pair = gwp.pairs.find(function (entry) { return entry.variant === parentID; });
      if (!expected || !pair || !Array.isArray(pair.catalogComponents) || pair.catalogComponents.length !== 2
          || pair.handVariant !== expected[0] || pair.bodyVariant !== expected[1]
          || pair.catalogComponents.some(function (component, index) {
            return component.variant_id !== expected[index] || component.quantity !== 1;
          })) return null;
      return { parent_variant_id: parentID, parent_quantity: 1, evidence: 'managed_parent_catalog_verified', components: pair.catalogComponents };
    }
    function mailAppliedDiscountCodes(cart) {
      return discountCodes(Object.assign({}, cart, {
        discount_codes: (cart.discount_codes || []).filter(function (item) { return item && item.applicable !== false; })
      }));
    }
    var cartSnapshotCapture = window.createHinokCartSnapshotCapture({
      origin: 'https://hinok.us',
      isSettledCart: function (cart) {
        return !pendingCartMutations && !gwpSyncInFlight && !checkoutInProgress && !gwpCheckoutBlocked
          && !careGiftError && !giftUnavailable && checkoutRequirementsMet(cart);
      },
      isGiftLine: mailGiftLine,
      resolveGiftComponents: resolveMailGiftComponents,
      recoveryDiscountCodes: function (cart) {
        return mailAppliedDiscountCodes(cart).filter(function (code) {
          return !carePromotionCodes().some(function (managed) { return managed.toLowerCase() === code.toLowerCase(); });
        });
      }
    });
    var checkoutMailStamp = window.createHinokCheckoutMailStamp({
      timeoutMs: 4500,
      isCurrent: function () { return checkoutInProgress && !pendingCartMutations; },
      isCartValid: function (cart) { return !gwpCheckoutBlocked && !careGiftError && checkoutRequirementsMet(cart); },
      isGiftLine: mailGiftLine,
      discountCodes: mailAppliedDiscountCodes,
      readCart: function (signal) { return mailCartRequest(routes.cart, null, signal); },
      updateAttributes: function (attributes, signal) {
        return mailCartRequest(routes.update, { attributes: Object.assign({}, mailCartAttributes, attributes) }, signal);
      }
    });
    function invalidatePreviousCheckoutStamp() {
      if (!drawer.dataset.mailSnapshotId) return Promise.resolve();
      var controller = new AbortController();
      var timer = window.setTimeout(function () { controller.abort(); }, 1500);
      return mailCartRequest(routes.update, { attributes: { _hinok_mail_snapshot_id: '' } }, controller.signal)
        .catch(function () { lastCheckoutMailStampResult = { ready: false, reason: 'invalidation_unconfirmed' }; })
        .finally(function () { window.clearTimeout(timer); });
    }
    var cartSnapshotRecheck = window.createHinokCartSnapshotRecheck({
      capture: cartSnapshotCapture,
      readCart: function () { return getCart().then(rememberMailCart); },
      isBusy: function () { return Boolean(pendingCartMutations || gwpSyncInFlight); },
      shouldStop: function () { return Boolean(checkoutInProgress); },
      onResult: function (result) { lastCartSnapshotResult = result; }
    }, window);
    function publishSettledCartSnapshot(ticket) {
      try { cartSnapshotRecheck.settled(ticket); } catch (_) {}
    }
    function prepareCheckoutMail(cart) {
      rememberMailCart(cart);
      return checkoutMailStamp.prepare(cart).then(function (result) {
        lastCheckoutMailStampResult = { ready: result.ready, reason: result.reason || 'verified', snapshotID: result.snapshotID || '',
          invalidationConfirmed: result.invalidationConfirmed, attestationMayBePresent: result.attestationMayBePresent };
        if (result.ready) rememberMailCart(result.cart);
        // Metadata is optional, actual gift validity remains mandatory even
        // if a property write unexpectedly changes discount allocation.
        return getCart().then(rememberMailCart);
      }).then(function (currentCart) {
        if (!checkoutRequirementsMet(currentCart)) {
          var error = new Error('Complimentary gift verification failed after email metadata');
          error.gwpCheckoutBlocked = true;
          throw error;
        }
        return currentCart;
      });
    }

    function careCartSnapshot() {
      return { items: Array.from(drawer.querySelectorAll('[data-cart-region="items"] [data-gwp-line]')).map(function (row) {
        return {
          variant_id: Number(row.dataset.variantId), quantity: Number(row.dataset.quantity),
          final_line_price: Number(row.dataset.lineTotal),
          properties: { _hinok_gwp: row.dataset.gwpMarker, _hinok_gwp_tier: row.dataset.gwpTier }
        };
      }) };
    }
    function updateCareMessage() {
      if (!gwp.tiered || careGiftError || gwpErrorMessage || drawer.classList.contains('is-cart-loading')) return;
      var message = drawer.querySelector('[data-gwp-message]');
      var total = Number(drawer.dataset.gwpQualifyingTotal) || 0;
      var mode = Number(drawer.dataset.itemCount) === 0 ? 'empty' : careGifts.valid(careCartSnapshot(), careGifts.fulfilment(total)) ? 'added' : 'pending';
      if (message) message.textContent = careGifts.message(total, mode);
    }
    function syncCartPageBenefits() {
      if (drawer.classList.contains('is-cart-loading')) return;
      var pageBenefits = document.querySelector('[data-cart-page-benefits]');
      var drawerBenefits = drawer.querySelector('[data-cart-region="shipping"]');
      if (pageBenefits && drawerBenefits) pageBenefits.innerHTML = drawerBenefits.innerHTML;
    }
    function updateCareBenefits() {
      if (!gwp.tiered || drawer.classList.contains('is-cart-loading')) return;
      updateCareMessage();
      var total = Number(drawer.dataset.gwpQualifyingTotal) || 0;
      var threshold = Number(drawer.dataset.freeShippingThreshold) || 0;
      var goal = careGifts.progressThreshold(threshold);
      var fill = drawer.querySelector('.cart-drawer__progress-fill');
      if (fill && goal > 0) fill.style.inlineSize = Math.min(100, total / goal * 100) + '%';
      var steps = [{ key: 'shipping', threshold: threshold, available: threshold > 0 && Boolean(drawer.querySelector('.cart-drawer__shipping-label')) }].concat(careGifts.tiers());
      steps.forEach(function (step) {
        var label = drawer.querySelector('[data-benefit-step="' + step.key + '"]');
        var mark = drawer.querySelector('[data-benefit-mark="' + step.key + '"]');
        if (label) {
          label.hidden = !step.available;
          var stepTotal = step.key === 'shipping' ? Number(drawer.dataset.cartTotal) || 0 : total;
          label.dataset.reached = String(stepTotal >= step.threshold);
        }
        if (mark) {
          mark.hidden = !step.available || goal <= 0;
          if (goal > 0) mark.style.insetInlineStart = Math.min(100, step.threshold / goal * 100) + '%';
        }
      });
      var dialog = document.querySelector('[data-care-gift-dialog]');
      var terms = drawer.querySelector('[data-care-gift-open]');
      if (terms) {
        terms.hidden = !dialog;
        if (dialog) terms.setAttribute('aria-controls', dialog.id);
      }
      var paidCart = { items: Array.from(drawer.querySelectorAll('[data-cart-region="items"] [data-key]:not([data-gwp-line])')).map(function (row) {
        return { handle: row.dataset.handle, quantity: Number(row.dataset.quantity) };
      }) };
      Array.from(drawer.querySelectorAll('[data-cart-region="items"] [data-gwp-line]')).forEach(function (row) {
        var note = row.querySelector('[data-gwp-overlap]');
        if (!note) return;
        var details = [];
        careGifts.eligible(total).filter(function (tier) { return row.dataset.gwpTier === 'care-pair' || row.dataset.gwpTier === tier.key; }).forEach(function (tier) {
          var counts = careGifts.paidOverlap(paidCart, tier.handle);
          var detail = '';
          if (counts.purchased && counts.bundled) detail = careGifts.copy('duplicate_both', counts);
          else if (counts.purchased) detail = careGifts.copy('duplicate_direct', { count: counts.purchased });
          else if (counts.bundled) detail = careGifts.copy('duplicate_set', { count: counts.bundled });
          if (detail) details.push(row.dataset.gwpTier === 'care-pair' ? careGifts.copy('duplicate_named', { product: tier.title, detail: detail }) : detail);
        });
        note.textContent = details.join('\n');
        note.hidden = !details.length;
      });
    }
    function renderPdpBenefits(benefit, total, hasSelection, shippingTotal) {
      if (!benefit || !benefit.hasAttribute('data-pdp-benefit-module')) return false;
      if (shippingTotal == null) shippingTotal = total;
      var active = careGifts.enabled();
      benefit.querySelector('[data-pdp-benefit-header]').hidden = !active;
      benefit.querySelector('[data-pdp-benefit-steps]').hidden = !active;
      var discovery = benefit.querySelector('[data-pdp-discovery-gift]');
      if (discovery) {
        discovery.hidden = !active || !careGifts.tiers().some(function (tier) {
          return tier.available && tier.handle === discovery.dataset.productHandle;
        });
        var discoveryDialog = discovery.querySelector('dialog');
        if (discovery.hidden && discoveryDialog.open) discoveryDialog.close();
      }
      if (!active) {
        benefit.querySelectorAll('[data-pdp-benefit-mark]').forEach(function (mark) { mark.hidden = true; });
        return false;
      }
      benefit.querySelector('[data-pdp-benefit-context]').textContent = hasSelection ? benefit.dataset.selectionLabel : benefit.dataset.cartLabel;
      benefit.querySelector('[data-pdp-benefit-shipping]').hidden = true;
      var threshold = Number(drawer.dataset.freeShippingThreshold) || 0;
      var goal = careGifts.progressThreshold(threshold);
      var fill = benefit.querySelector('.cart-drawer__progress-fill');
      fill.parentElement.hidden = goal <= 0;
      fill.style.inlineSize = (goal > 0 ? Math.min(100, total / goal * 100) : 0) + '%';
      var confirmed = hasSelection || careGifts.valid(careCartSnapshot(), careGifts.fulfilment(total));
      var tiers = careGifts.tiers();
      var steps = [{ key: 'shipping', threshold: threshold, available: threshold > 0 }].concat(tiers);
      steps.forEach(function (step) {
        var label = benefit.querySelector('[data-pdp-benefit-step="' + step.key + '"]');
        if (label) {
          var stepTotal = step.key === 'shipping' ? shippingTotal : total;
          var reached = step.available && stepTotal >= step.threshold && (step.key === 'shipping' || confirmed);
          label.hidden = !step.available;
          label.dataset.reached = String(reached);
          label.querySelector('[data-pdp-benefit-amount]').textContent = careGifts.copyAmount(step.threshold);
          label.querySelector('[data-pdp-benefit-check]').hidden = !reached;
        }
        var mark = benefit.querySelector('[data-pdp-benefit-mark="' + step.key + '"]');
        if (mark) {
          mark.hidden = !step.available || goal <= 0 || step.threshold >= goal;
          if (goal > 0) mark.style.insetInlineStart = Math.min(100, step.threshold / goal * 100) + '%';
        }
      });
      var available = tiers.filter(function (tier) { return tier.available; });
      var next = available.find(function (tier) { return total < tier.threshold; });
      var unavailable = tiers.filter(function (tier) { return !tier.available && total >= tier.threshold; });
      var message = benefit.querySelector('[data-pdp-benefit-gift]');
      message.hidden = false;
      if (!hasSelection) {
        message.textContent = drawer.querySelector('[data-gwp-message]')?.textContent || careGifts.message(total, 'included');
      } else if (!available.length) {
        message.textContent = careGifts.copy('unavailable');
      } else {
        var parts = [];
        if (next) parts.push(careGifts.copy('away', { amount: careGifts.copyAmount(next.threshold - total), product: next.title }));
        unavailable.forEach(function (tier) { parts.push(careGifts.copy('gift_unavailable', { product: tier.title })); });
        if (!parts.length) parts.push(available.length === tiers.length && available.length > 1 ? benefit.dataset.completedLabel : careGifts.message(total, 'included'));
        message.textContent = parts.join('\n');
      }
      if (benefit.dataset.giftValue && available.some(function (tier) { return tier.handle === benefit.dataset.giftValueHandle; })) {
        message.textContent = message.textContent.replace(/\.\s*$/, '') + '\u00a0';
        var value = document.createElement('span');
        value.className = 'pdp-benefits__value';
        value.textContent = benefit.dataset.giftValue;
        message.appendChild(value);
      }
      var dialog = document.querySelector('[data-care-gift-dialog]');
      var terms = benefit.querySelector('[data-care-gift-open]');
      terms.hidden = !dialog;
      if (dialog) terms.setAttribute('aria-controls', dialog.id);
      return true;
    }
    window.hinokRenderPdpBenefits = renderPdpBenefits;
    function updatePdpBenefits() {
      var benefit = document.querySelector('[data-pdp-benefits]');
      if (!benefit) return;
      benefit.hidden = !careGifts.enabled();
      var pdp = benefit.closest('[data-pdp]');
      var shippingNote = pdp.querySelector('[data-pdp-shipping-note]');
      if (shippingNote) shippingNote.hidden = !benefit.hidden;
      if (benefit.hidden) {
        renderPdpBenefits(benefit, 0, false);
        return;
      }
      var selection = pdp.querySelector('.pdp-size.is-selected') || pdp.querySelector('[data-pdp-atc]');
      var total = (Number(drawer.dataset.gwpQualifyingTotal) || 0) + (Number(selection.dataset.variantPrice) || 0);
      var shippingTotal = (Number(drawer.dataset.cartTotal) || 0) + (Number(selection.dataset.variantPrice) || 0);
      if (renderPdpBenefits(benefit, total, true, shippingTotal)) return;
      var threshold = Number(drawer.dataset.freeShippingThreshold) || 0;
      var shipping = benefit.querySelector('[data-pdp-benefit-shipping]');
      shipping.hidden = threshold <= 0;
      shipping.textContent = total < threshold ? drawer.dataset.shippingAway.replace('[amount]', careGifts.copyAmount(threshold - total)) : drawer.dataset.shippingReceived;
      benefit.querySelector('[data-pdp-benefit-gift]').textContent = careGifts.message(total, 'included');
      var goal = careGifts.progressThreshold(threshold);
      benefit.querySelector('.cart-drawer__progress-fill').style.inlineSize = (goal > 0 ? Math.min(100, total / goal * 100) : 100) + '%';
    }
    document.addEventListener('pdp:variant-change', updatePdpBenefits);
    var hideTimer = null;
    var lastFocus = null;

    function open(skipGwpSync) {
      if (drawer.classList.contains('is-open')) return;
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      var nav = document.getElementById('nav-drawer');
      if (nav && !nav.hidden) {
        var navClose = nav.querySelector('[data-nav-close]');
        if (navClose) navClose.click();
      }
      lastFocus = document.activeElement;
      drawer.hidden = false;
      /* A reopened drawer is a new recommendation exposure. Recompute after it
         becomes measurable so impression events reflect what the customer sees. */
      lastRecoImpressionSignature = null;
      computeRecos();
      void drawer.offsetWidth;
      anchorReco();
      drawer.classList.add('is-open');
      if (gwp.enabled) {
        captureCartEvent('gwp_offer_viewed', {
          threshold_cents: gwp.threshold,
          qualifying_subtotal_cents: parseInt(drawer.getAttribute('data-gwp-qualifying-total'), 10) || 0
        });
      }
      if (skipGwpSync !== true && !drawer.classList.contains('is-cart-loading')) queue.then(function () { return scheduleGwpSync(); }).catch(fail);
      /* Second pass one frame later: with prefers-reduced-motion the panel
         snaps straight to scale(1) and no transitionend ever fires, so this
         is the only chance for the fold feedback pass to run at scale 1.
         With normal motion it lands mid-bloom and is a harmless no-op. */
      requestAnimationFrame(anchorReco);
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.focus();
    }
    function showAddedCart() {
      var scroller = drawer.querySelector('.cart-drawer__scroll');
      if (scroller) scroller.scrollTop = 0;
      open(true);
    }
    function close() {
      // Guard against repeats (ESC auto-repeat / double-tap): a second call used
      // to queue an orphaned timer that hid the drawer after it was reopened.
      if (!drawer.classList.contains('is-open')) return;
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      hideTimer = setTimeout(function () {
        drawer.hidden = true;
        hideTimer = null;
      }, 420);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* aria-modal promises containment — wrap Tab inside the panel (WCAG 2.4.3) */
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || drawer.hidden) return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null && !el.closest('[inert]'); });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    function showError(message) {
      var elements = Array.prototype.slice.call(document.querySelectorAll('[data-cart-error], [data-gwp-checkout-error]'));
      if (!elements.length) return;
      elements.forEach(function (el) {
        el.textContent = message || drawer.getAttribute('data-error-generic') || 'Something went wrong.';
        el.hidden = false;
      });
      clearTimeout(showError.timer);
      showError.timer = setTimeout(function () {
        elements.forEach(function (el) { el.hidden = true; });
      }, 6000);
    }
    function clearError() {
      Array.prototype.slice.call(document.querySelectorAll('[data-cart-error], [data-gwp-checkout-error], [data-cart-line-error]')).forEach(function (el) {
        el.hidden = true;
      });
    }
    function fail(err, row) {
      console.warn('[cart] request failed:', err);
      var message = err && !err.cartResponseInvalid && !err.cartTemporary ? err.message : null;
      if (row && row.isConnected) {
        var lineError = row.querySelector('[data-cart-line-error]');
        if (!lineError) {
          lineError = document.createElement('p');
          lineError.className = 'cart-item__error';
          lineError.setAttribute('data-cart-line-error', '');
          lineError.setAttribute('role', 'alert');
          row.appendChild(lineError);
        }
        lineError.textContent = message || drawer.getAttribute('data-error-generic');
        lineError.hidden = false;
      } else showError(message);
    }

    function setHeaderCount(count) {
      Array.prototype.slice.call(document.querySelectorAll('.site-header__count')).forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    /* Anchor the recommendations: measure how tall "reco top padding + tabs +
       first visible row" really is and expose it as --reco-anchor; the items
       region's min-height (see stylesheet) then parks the reco block with the
       first row FULLY visible above the footer. The old fixed 166px assumed
       exact tab/row heights and cut the first row mid-image on some devices.
       Re-measured on every open, resize, and tab switch (row heights can
       differ per tab). Only vertical DISTANCES are read, so the panel's
       translateX slide-in never skews the numbers; skipped while the drawer
       is display-hidden (rects would read 0). */
    function anchorReco() {
      if (drawer.hidden) return;
      var reco = drawer.querySelector('.cart-drawer__reco');
      if (!reco || !reco.offsetHeight) return;
      var list = reco.querySelector('[data-cart-tabpanel]:not([hidden])');
      /* Peek edge: the SECOND visible row's title baseline — first row shows
         in full, the second row's thumbnail-top + title peek past the fold as
         the "there is more" scroll hint (Ruben's mockup, 2026-07-09).
         Dedupe-hidden rows are skipped. Fallbacks: one row → that row in
         full; no rows → the tab bar. */
      var rows = list ? list.querySelectorAll('.cart-item:not([hidden])') : [];
      var target = null;
      if (rows.length > 1) target = rows[1].querySelector('.cart-item__title') || rows[0];
      else if (rows.length) target = rows[0];
      if (!target) target = reco.querySelector('.cart-drawer__tabs') || reco;
      var rect = reco.getBoundingClientRect();
      /* The panel opens through a scale(0.985) bloom, and rects measured
         mid-bloom shrink by that factor while layout metrics don't — derive
         the live scale (rect height vs layout height) and divide it out so
         the anchor is in layout px. */
      var scale = rect.height / reco.offsetHeight || 1;
      var peek = (target.getBoundingClientRect().bottom - rect.top) / scale;
      var margin = parseFloat(getComputedStyle(reco).marginBlockStart) || 0;
      if (peek <= 0) return;
      var anchor = Math.ceil(peek + margin);
      drawer.style.setProperty('--reco-anchor', anchor + 'px');
      /* Feedback pass: the percentage min-height resolves against a fractional
         flex height, so one layout with the anchor applied can still leave the
         row a px or two past the fold — measure the residual overhang against
         the scroll viewport edge and absorb it. Only meaningful at rest
         (scrollTop 0) and once the bloom has settled (scale ~1); the
         transitionend re-run below covers the settled state after opening. */
      var scroll = drawer.querySelector('.cart-drawer__scroll');
      if (!scroll || scroll.scrollTop > 0 || Math.abs(scale - 1) > 0.002) return;
      var fold = scroll.getBoundingClientRect().top + scroll.clientTop + scroll.clientHeight;
      var overhang = target.getBoundingClientRect().bottom - fold;
      if (overhang > 0) drawer.style.setProperty('--reco-anchor', (anchor + Math.ceil(overhang)) + 'px');
    }
    drawer.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'transform' && e.target.classList && e.target.classList.contains('cart-drawer__panel')) anchorReco();
    });

    /* Cross-sell map: anchor product handle -> ordered reco handles, rendered as
       JSON by snippets/cart-crosssell-map.liquid from the ops market-basket doc. */
    function parseCrossMap() {
      var el = drawer.querySelector('[data-crosssell-map]');
      if (!el) return {};
      try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
    }
    var crossMap = parseCrossMap();
    var intentAnchorKey = 'hinok_cart_intent_anchor';
    var intentAnchorHandle = null;
    var activeRecoContext = { handle: null, method: 'fallback', variantId: null };
    var lastRecoImpressionSignature = null;

    try { intentAnchorHandle = window.sessionStorage.getItem(intentAnchorKey); } catch (e) {}

    function storeIntentAnchor(handle) {
      intentAnchorHandle = handle || null;
      try {
        if (intentAnchorHandle) window.sessionStorage.setItem(intentAnchorKey, intentAnchorHandle);
        else window.sessionStorage.removeItem(intentAnchorKey);
      } catch (e) {}
    }

    function captureCartEvent(name, props) {
      if (name.indexOf('gwp_') === 0) {
        props = Object.assign({ campaign_id: gwp.marker }, props || {});
      }
      if (window.posthog && window.posthog.capture) window.posthog.capture(name, props || {});
    }

    function recommendationProps(anchorHandle, anchorMethod, row, slot) {
      var subtotal = parseInt(drawer.getAttribute('data-cart-total'), 10) || 0;
      var threshold = parseInt(drawer.getAttribute('data-free-shipping-threshold'), 10) || 0;
      var candidatePrice = parseInt(row.getAttribute('data-price'), 10) || 0;
      return {
        intent_anchor: anchorHandle,
        anchor_method: anchorMethod,
        anchor_variant_id: activeRecoContext.variantId,
        candidate_handle: row.getAttribute('data-handle'),
        candidate_variant_id: row.getAttribute('data-variant-id'),
        slot: slot,
        cart_subtotal_cents: subtotal,
        candidate_price_cents: candidatePrice,
        gifting_promotion: careGifts.enabled() ? gwp.marker : null,
        paid_subtotal_cents: Number(drawer.dataset.gwpQualifyingTotal) || 0,
        gift_tiers_after_add: careGifts.eligible((Number(drawer.dataset.gwpQualifyingTotal) || 0) + candidatePrice).map(function (tier) { return tier.key; }),
        free_shipping_unlocked: threshold > 0 && subtotal < threshold && subtotal + candidatePrice >= threshold
      };
    }

    /* Recompute both reco tabs against the current cart. Runs on init and after
       every mutation (the reco block itself is deliberately NOT swapped, so tab
       state survives; this re-syncs visibility instead).

       Tab A "Best sellers" is intent-driven: the latest successful EXTERNAL ATC
       remains the anchor while in-drawer recommendation adds do not replace it.
       A valid session intent wins; otherwise the highest unit-price cart line is
       the recovery fallback. The map list then drops products already in cart and
       out-of-stock rows, fills to data-reco-max from _fallback, and is moved into
       map order. An empty cart uses its own _empty merchandising list rather than
       the unknown-anchor fallback.

       Tab B "Gifts & bundles" keeps the collection dedupe + visible cap (by id).
       Re-anchors the layout after, since which rows are visible moves the peek
       edge. */
    function computeRecos() {
      var journey = window.HinokSprayJourney;
      var journeyContext = journey && journey.cartContext();
      var recoMax = parseInt(drawer.getAttribute('data-reco-max'), 10) || 3;

      var inCartHandle = {}, inCartId = {}, rowByCartHandle = {};
      var highestHandle = null, highestPrice = -1;
      Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-region="items"] [data-product-id]')).forEach(function (el) {
        var pid = el.getAttribute('data-product-id');
        if (pid) inCartId[pid] = true;
        var h = el.getAttribute('data-handle');
        if (el.hasAttribute('data-gwp-line') && gwp.marker === 'to-go-70') {
          inCartHandle[gwp.productHandle] = true;
          inCartHandle[gwp.fallbackHandle] = true;
        }
        if (h) {
          inCartHandle[h] = true;
          if (el.hasAttribute('data-gwp-line')) return;
          rowByCartHandle[h] = el;
          var pr = parseInt(el.getAttribute('data-price'), 10);
          if (!isNaN(pr) && pr > highestPrice) { highestPrice = pr; highestHandle = h; }
        }
      });

      var paidTotal = Number(drawer.dataset.gwpQualifyingTotal) || 0;
      var cartHandles = Object.keys(inCartHandle);
      Array.from(drawer.querySelectorAll('[data-gwp-line]')).forEach(function (row) {
        var tier = gwp.tiers.find(function (item) { return item.key === row.dataset.gwpTier; });
        if (tier && cartHandles.indexOf(tier.handle) === -1) cartHandles.push(tier.handle);
        if (row.dataset.gwpTier === 'care-pair') gwp.tiers.forEach(function (giftTier) { if (cartHandles.indexOf(giftTier.handle) === -1) cartHandles.push(giftTier.handle); });
      });
      var cartItemCount = Object.keys(rowByCartHandle).length;
      var anchorHandle = null, anchorMethod = cartItemCount === 0 ? 'empty_cart' : 'fallback';
      if (cartItemCount === 0) {
        if (intentAnchorHandle) storeIntentAnchor(null);
      } else if (intentAnchorHandle && rowByCartHandle[intentAnchorHandle]) {
        anchorHandle = intentAnchorHandle;
        anchorMethod = 'external_atc';
      } else {
        if (intentAnchorHandle) storeIntentAnchor(null);
        if (highestHandle) {
          anchorHandle = highestHandle;
          anchorMethod = 'highest_price_fallback';
        }
      }
      if (journeyContext) {
        anchorHandle = 'the-spray-set';
        anchorMethod = 'spray_set_journey';
      }
      var anchorRow = anchorHandle && rowByCartHandle[anchorHandle];
      activeRecoContext = {
        handle: anchorHandle,
        method: anchorMethod,
        variantId: journeyContext ? journeyContext.variantId : anchorRow && anchorRow.getAttribute('data-variant-id')
      };
      drawer.setAttribute('data-reco-anchor', anchorHandle || '');
      drawer.setAttribute('data-reco-anchor-method', anchorMethod);

      var listA = drawer.querySelector('[data-cart-tabpanel="a"]');
      if (listA) {
        var rowByHandle = {};
        Array.prototype.slice.call(listA.querySelectorAll('[data-reco][data-handle]')).forEach(function (el) {
          rowByHandle[el.getAttribute('data-handle')] = el;
          el.removeAttribute('data-reco-slot');
          el.hidden = true;
        });
        var fallback = journeyContext ? [] : crossMap._fallback || [];
        var empty = crossMap._empty || fallback;
        var primary = anchorMethod === 'empty_cart'
          ? empty
          : ((anchorHandle && crossMap[anchorHandle]) || fallback);
        if (journeyContext) primary = journeyContext.order;
        var ordered = primary.slice();
        Array.prototype.push.apply(ordered, fallback); // top-up when the list runs thin
        if (careGifts.enabled()) {
          var careBackfill = crossMap._care_backfill || {};
          Array.prototype.push.apply(ordered, careBackfill[anchorHandle] || []);
          var candidates = {};
          Object.keys(rowByHandle).forEach(function (handle) {
            var row = rowByHandle[handle];
            candidates[handle] = { handle: handle, price: Number(row.dataset.price), available: row.dataset.available !== 'false' };
          });
          ordered = careGifts.rank(ordered, candidates, paidTotal, cartHandles);
        }
        var chosen = [];
        for (var i = 0; i < ordered.length && chosen.length < recoMax; i++) {
          var h = ordered[i];
          if (chosen.indexOf(h) !== -1 || inCartHandle[h] === true) continue;
          var row = rowByHandle[h];
          if (!row || row.getAttribute('data-available') === 'false') continue;
          chosen.push(h);
        }
        chosen.forEach(function (h, index) {
          var row = rowByHandle[h];
          listA.appendChild(row); // reveal in the chosen order (visible rows last)
          row.setAttribute('data-reco-slot', index + 1);
          var qty = row.querySelector('[data-reco-qty]');
          if (qty) qty.textContent = 0; /* not in cart yet — "+" adds it */
          row.hidden = false;
        });

        if (!drawer.hidden && !listA.hidden && chosen.length) {
          var signature = [anchorHandle || '', anchorMethod, activeRecoContext.variantId || ''].concat(chosen).join('|');
          if (signature !== lastRecoImpressionSignature) {
            lastRecoImpressionSignature = signature;
            chosen.forEach(function (h, index) {
              captureCartEvent(
                'minicart_reco_impression',
                recommendationProps(anchorHandle, anchorMethod, rowByHandle[h], index + 1)
              );
            });
          }
        }
      }

      var listB = drawer.querySelector('[data-cart-tabpanel="b"]');
      if (listB) {
        var rowsB = Array.from(listB.querySelectorAll('[data-reco][data-product-id]'));
        var orderedB = rowsB.slice();
        if (careGifts.enabled()) {
          orderedB.sort(function (a, b) {
            var aDecision = careGifts.decision({ handle: a.dataset.handle, price: Number(a.dataset.price), available: a.dataset.available !== 'false' }, paidTotal, cartHandles);
            var bDecision = careGifts.decision({ handle: b.dataset.handle, price: Number(b.dataset.price), available: b.dataset.available !== 'false' }, paidTotal, cartHandles);
            return aDecision.penalty - bDecision.penalty;
          });
        }
        var shown = 0;
        orderedB.forEach(function (el) {
          var excluded = journeyContext && ['the-spray-bottle-empty', 'the-spray-gift-set', 'the-spray-hand-wash-set', 'the-shower-set'].indexOf(el.dataset.handle) !== -1;
          var decision = careGifts.decision({ handle: el.dataset.handle, price: Number(el.dataset.price), available: el.dataset.available !== 'false' }, paidTotal, cartHandles);
          var hide = excluded || decision.blocked || inCartId[el.dataset.productId] === true || shown >= recoMax;
          if (!hide) {
            shown++;
            if (el.hidden) {
              var qty = el.querySelector('[data-reco-qty]');
              if (qty) qty.textContent = 0;
            }
            if (careGifts.enabled()) listB.appendChild(el);
          }
          el.hidden = hide;
        });
      }
      updateCareBenefits();
      if (journey && !drawer.classList.contains('is-cart-loading')) journey.updateCartBenefits();
      syncCartPageBenefits();
      updatePdpBenefits();
      document.dispatchEvent(new CustomEvent('cart:rendered'));
      anchorReco();
    }
    document.addEventListener('spray-journey:ready', computeRecos);
    document.addEventListener('cart:open', open);
    window.addEventListener('resize', function () {
      if (!drawer.hidden) requestAnimationFrame(anchorReco);
    });

    function cartRowContent(row) {
      var copy = row.cloneNode(true);
      copy.removeAttribute('data-key');
      Array.from(copy.querySelectorAll('[data-qty-step], [data-cart-remove]')).forEach(function (control) {
        control.removeAttribute('disabled');
      });
      Array.from(copy.querySelectorAll('img')).forEach(function (img) {
        img.classList.remove('is-loaded');
        img.removeAttribute('data-reveal-watched');
        if (img.style.transition === 'none') img.style.removeProperty('transition');
        if (!img.getAttribute('style')) img.removeAttribute('style');
      });
      return copy;
    }
    function swapFromSectionHtml(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      window.HinokCartLineGroups.render(doc);
      ['shipping', 'items', 'totals'].forEach(function (name) {
        var next = doc.querySelector('[data-cart-region="' + name + '"]');
        var cur = drawer.querySelector('[data-cart-region="' + name + '"]');
        if (!next || !cur) return;
        if (name === 'shipping' && drawer.classList.contains('is-cart-loading')) {
          pendingShippingRegion = next;
          return;
        }
        var nextList = name === 'items' && next.querySelector('.cart-drawer__items');
        var curList = name === 'items' && cur.querySelector('.cart-drawer__items');
        if (!nextList || !curList) {
          if (!cur.isEqualNode(next)) cur.replaceWith(next);
          return;
        }
        var rows = new Map(Array.from(curList.children).map(function (row) { return [row.getAttribute('data-key'), row]; }));
        Array.from(nextList.children).forEach(function (nextRow, index) {
          var key = nextRow.getAttribute('data-key');
          var existing = key && rows.get(key);
          var nextContent = cartRowContent(nextRow);
          if (!existing && key) {
            existing = Array.from(rows.values()).find(function (row) {
              return row.getAttribute('data-variant-id') === nextRow.getAttribute('data-variant-id') && cartRowContent(row).isEqualNode(nextContent);
            });
          }
          var row = existing && cartRowContent(existing).isEqualNode(nextContent) ? existing : nextRow;
          if (existing) rows.delete(existing.getAttribute('data-key'));
          if (row === existing) row.setAttribute('data-key', key);
          if (existing && row !== existing) existing.replaceWith(row);
          if (curList.children[index] !== row) curList.insertBefore(row, curList.children[index] || null);
          rows.delete(key);
        });
        rows.forEach(function (row) { row.remove(); });
      });
      // Keep stock decisions current after a cart refresh without replacing row controls.
      Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-tabpanel] [data-reco]')).forEach(function (row) {
        var tab = row.closest('[data-cart-tabpanel]').getAttribute('data-cart-tabpanel');
        var selector = '[data-cart-tabpanel="' + tab + '"] [data-handle="' + row.getAttribute('data-handle') + '"]';
        var nextRow = doc.querySelector(selector);
        row.setAttribute('data-available', nextRow ? nextRow.getAttribute('data-available') : 'false');
        if (nextRow) {
          ['data-price', 'data-variant-id'].forEach(function (name) { row.setAttribute(name, nextRow.getAttribute(name)); });
          ['.cart-item__volume', '.cart-item__price'].forEach(function (selector) {
            var current = row.querySelector(selector);
            var next = nextRow.querySelector(selector);
            if (current && next) current.textContent = next.textContent;
          });
        }
      });
      var nextCount = doc.querySelector('[data-cart-count-label]');
      var curCount = drawer.querySelector('[data-cart-count-label]');
      if (nextCount && curCount) curCount.replaceWith(nextCount);
      var root = doc.querySelector('[data-cart-drawer]');
      if (root) {
        Array.prototype.slice.call(root.attributes).forEach(function (attribute) {
          if (attribute.name.indexOf('data-gwp-') === 0) drawer.setAttribute(attribute.name, attribute.value);
        });
        drawer.dataset.mailSnapshotId = root.getAttribute('data-mail-snapshot-id') || '';
        readGwpConfig();
        var n = parseInt(root.getAttribute('data-item-count'), 10);
        if (!isNaN(n)) {
          drawer.setAttribute('data-item-count', n);
          setHeaderCount(n);
        }
        var total = parseInt(root.getAttribute('data-cart-total'), 10);
        if (!isNaN(total)) drawer.setAttribute('data-cart-total', total);
        var qualifyingTotal = parseInt(root.getAttribute('data-gwp-qualifying-total'), 10);
        if (!isNaN(qualifyingTotal)) drawer.setAttribute('data-gwp-qualifying-total', qualifyingTotal);
      }
      updateGiftPresentation();
    }

    function renderCartSections(sections) {
      if (!sections || !sections['cart-drawer']) return false;
      swapFromSectionHtml(sections['cart-drawer']);
      var cartPage = document.querySelector('[data-cart-page-section]');
      if (cartPage && sections[cartPage.getAttribute('data-cart-page-section')]) {
        var nextPage = new DOMParser().parseFromString(sections[cartPage.getAttribute('data-cart-page-section')], 'text/html').querySelector('[data-cart-page-section]');
        if (nextPage) window.HinokCartLineGroups.render(nextPage);
        if (nextPage && !cartPage.isEqualNode(nextPage)) cartPage.replaceWith(nextPage);
      }
      setCartPageBusy(drawer.classList.contains('is-cart-loading'), drawer.classList.contains('is-gwp-syncing'));
      return true;
    }

    /* Mutations run through a serial queue: rapid taps (e.g. two product-card
       ATCs back to back) wait their turn instead of being silently dropped. */
    var queue = Promise.resolve();
    function parseCartResponse(res) {
      var contentType = (res.headers.get('content-type') || '').toLowerCase();
      var expectsJson = contentType.indexOf('application/json') > -1 || contentType.indexOf('text/javascript') > -1;
      return res.text().then(function (body) {
        if (!expectsJson) {
          var responseError = new Error(drawer.getAttribute('data-error-generic') || 'Something went wrong.');
          responseError.cartResponseInvalid = true;
          responseError.cartTemporary = res.status === 429 || res.status === 503;
          responseError.cartStatus = res.status;
          throw responseError;
        }
        var data = {};
        try {
          data = body ? JSON.parse(body) : {};
        } catch (parseError) {
          var jsonError = new Error(drawer.getAttribute('data-error-generic') || 'Something went wrong.');
          jsonError.cartResponseInvalid = true;
          jsonError.cartTemporary = res.status === 429 || res.status === 503;
          jsonError.cartStatus = res.status;
          throw jsonError;
        }
        if (!res.ok) {
          var requestError = new Error((data && data.description) || res.statusText || drawer.getAttribute('data-error-generic'));
          requestError.cartStatus = res.status;
          throw requestError;
        }
        return data;
      });
    }

    function isCartSnapshot(data) {
      return data && Array.isArray(data.items) && typeof data.item_count === 'number' && typeof data.total_price === 'number';
    }

    function queueCartMutation(operation) {
      var run = function () { return Promise.resolve(gwpSyncInFlight).then(operation); };
      var turn = queue.then(run, run);
      queue = turn.then(function () {}, function () {});
      return turn;
    }
    window.hinokQueueCartMutation = queueCartMutation;

    function request(url, payload, nextIntentHandle, beforeCompute, skipGwpSync, skipSections) {
      var run = function () {
        if (!skipGwpSync) drawer.classList.add('is-busy');
        var cartPage = document.querySelector('[data-cart-page-section]');
        if (!skipSections && (!skipGwpSync || url !== routes.add)) {
          payload.sections = ['cart-drawer'].concat(cartPage ? [cartPage.getAttribute('data-cart-page-section')] : []);
          payload.sections_url = window.location.pathname;
        }
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(parseCartResponse)
          .then(function (data) {
            if (skipGwpSync) {
              if (data.sections && data.sections['cart-drawer']) pendingGiftSections = data.sections;
              return data;
            }
            var rendered = renderCartSections(data.sections);
            return (rendered ? Promise.resolve() : refreshJourneyCart()).then(function () {
              /* Apply the intent only after its own queued add succeeds. This
                 keeps rapid external ATCs ordered A → B instead of letting B's
                 early click overwrite A before A's response is rendered. */
              if (nextIntentHandle) storeIntentAnchor(nextIntentHandle);
              if (beforeCompute) beforeCompute(data);
              computeRecos();
              clearError();
              return data;
            });
          })
          .finally(function () {
            if (!skipGwpSync) drawer.classList.remove('is-busy');
          });
      };
      if (skipGwpSync) return run();
      var snapshotTicket = cartSnapshotCapture.noteMutation(url === routes.add ? 'paid_add' : 'paid_change');
      try { cartSnapshotRecheck.begin(snapshotTicket); } catch (_) {}
      pendingCartMutations++;
      setGwpBusy(true);
      var operation = function () {
        return invalidatePreviousCheckoutStamp().then(run).then(function (data) {
          return scheduleGwpSync(isCartSnapshot(data) ? data : null, true).then(function () { return data; });
        });
      };
      return queueCartMutation(operation).finally(function () {
        pendingCartMutations--;
        setGwpBusy(false);
      }).then(function (data) {
        publishSettledCartSnapshot(snapshotTicket);
        return data;
      });
    }

    function addToCart(variantId, quantity, nextIntentHandle, beforeCompute, properties) {
      var item = { id: variantId, quantity: quantity };
      if (properties && Object.keys(properties).length) item.properties = properties;
      return request(routes.add, { items: [item] }, nextIntentHandle, function (data) {
        if (beforeCompute) beforeCompute(data);
        showAddedCart();
      });
    }
    function changeLine(row, quantity) {
      return window.HinokCartLineGroups.change(row, quantity, routes, request);
    }

    function setCartPageBusy(working, checkoutLocked) {
      var page = document.querySelector('[data-cart-page-section]');
      if (!page) return;
      working = Boolean(working);
      checkoutLocked = Boolean(checkoutLocked);
      page.classList.toggle('is-cart-loading', working);
      var loading = page.querySelector('[data-cart-page-loading]');
      if (loading) loading.hidden = !working;
      Array.from(page.querySelectorAll('[data-gwp-checkout-form], [data-cart-page-benefits]')).forEach(function (region) {
        region.inert = working;
        if (working) region.setAttribute('aria-busy', 'true');
        else region.removeAttribute('aria-busy');
      });
      Array.from(page.querySelectorAll('[data-gwp-checkout]')).forEach(function (checkout) {
        if (checkoutLocked) checkout.setAttribute('aria-disabled', 'true');
        else checkout.removeAttribute('aria-disabled');
        if (working) checkout.setAttribute('aria-busy', 'true');
        else checkout.removeAttribute('aria-busy');
        if (checkout.tagName === 'BUTTON') checkout.disabled = checkoutLocked;
      });
    }

    function setGwpBusy(busy) {
      var working = Boolean(busy || pendingCartMutations || gwpSyncInFlight || checkoutInProgress);
      busy = working || gwpCheckoutBlocked;
      drawer.classList.toggle('is-gwp-syncing', busy);
      drawer.classList.toggle('is-cart-loading', working);
      var loading = drawer.querySelector('[data-cart-loading]');
      if (loading) loading.hidden = !working;
      if (!working && pendingShippingRegion) {
        var shipping = drawer.querySelector('[data-cart-region="shipping"]');
        if (shipping) shipping.replaceWith(pendingShippingRegion);
        pendingShippingRegion = null;
      }
      Array.from(drawer.querySelectorAll('.cart-drawer__shipping, .cart-drawer__scroll, .cart-drawer__footer')).forEach(function (region) {
        region.inert = working;
        if (working) region.setAttribute('aria-busy', 'true');
        else region.removeAttribute('aria-busy');
      });
      Array.prototype.slice.call(document.querySelectorAll('[data-gwp-checkout]')).forEach(function (checkout) {
        if (busy) checkout.setAttribute('aria-disabled', 'true');
        else checkout.removeAttribute('aria-disabled');
        if (working) checkout.setAttribute('aria-busy', 'true');
        else checkout.removeAttribute('aria-busy');
        if (checkout.tagName === 'BUTTON') checkout.disabled = busy;
      });
      setCartPageBusy(working, busy);
      updateGiftPresentation();
      if (!working && window.HinokSprayJourney) window.HinokSprayJourney.updateCartBenefits();
      if (!working && gwpErrorMessage) setGwpMessage(gwpErrorMessage);
      if (!working) updateCareBenefits();
      if (!working) syncCartPageBenefits();
    }

    function updateGiftPresentation() {
      var syncing = drawer.classList.contains('is-gwp-syncing');
      Array.from(drawer.querySelectorAll('[data-cart-region="items"] [data-qty-step], [data-cart-region="items"] [data-cart-remove]')).forEach(function (control) {
        control.disabled = syncing;
      });
      var expected = careGifts.fulfilment(Number(drawer.dataset.gwpQualifyingTotal) || 0);
      var chargedGift = false;
      Array.from(drawer.querySelectorAll('[data-cart-region="items"] [data-gwp-line]')).forEach(function (row) {
        var free = Number(row.dataset.lineTotal) === 0;
        chargedGift = chargedGift || !free;
        var current = !gwp.tiered || expected.some(function (tier) { return tier.key === row.dataset.gwpTier && tier.variant === Number(row.dataset.variantId); });
        row.hidden = syncing && (!free || !current);
      });
      var total = drawer.querySelector('[data-cart-estimated-total]');
      if (syncing && chargedGift && total && drawer.dataset.gwpPaidTotal) total.textContent = drawer.dataset.gwpPaidTotal;
    }

    function setGwpMessage(type) {
      if (type === 'discount-error' || type === 'unavailable') gwpErrorMessage = type;
      if (drawer.classList.contains('is-cart-loading')) return;
      var message = drawer.querySelector('[data-gwp-message]');
      if (!message) return;
      if (gwp.tiered && ['qualifying', 'added'].indexOf(type) !== -1) {
        var total = Number(drawer.dataset.gwpQualifyingTotal) || 0;
        message.textContent = careGifts.message(total, type === 'added' ? 'added' : 'pending');
        document.dispatchEvent(new CustomEvent('cart:rendered'));
        return;
      }
      var journeyValue = !gwp.tiered && window.HinokSprayJourney && window.HinokSprayJourney.giftMessage(type);
      var value = journeyValue || drawer.getAttribute('data-gwp-message-' + type);
      if (value) message.textContent = value;
      document.dispatchEvent(new CustomEvent('cart:rendered'));
    }

    function getCart(attempt) {
      attempt = attempt || 0;
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      return fetch(routes.cart, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal
      }).then(parseCartResponse).then(function (cart) {
        if (!isCartSnapshot(cart)) {
          var invalidCart = new Error(drawer.getAttribute('data-error-generic'));
          invalidCart.cartResponseInvalid = true;
          throw invalidCart;
        }
        return cart;
      }).finally(function () {
        clearTimeout(timeout);
      }).catch(function (err) {
        // Retry reads only. Replaying a cart mutation could duplicate merchandise.
        var temporary = err.name === 'TypeError' || err.name === 'AbortError'
          || err.cartStatus === 429 || err.cartStatus >= 500;
        if (attempt === 0 && temporary) {
          return new Promise(function (resolve) { setTimeout(resolve, 500); })
            .then(function () { return getCart(1); });
        }
        err.cartStage = 'cart_read';
        err.cartReadAttempts = attempt + 1;
        throw err;
      });
    }

    function isManagedGift(item) {
      return careGifts.managed(item);
    }

    function giftLines(cart) {
      return (cart.items || []).filter(isManagedGift);
    }

    function qualifyingSubtotal(cart) {
      return careGifts.subtotal(cart);
    }

    function discountCodes(cart) {
      var found = [];
      function add(code) {
        if (!code) return;
        var exists = found.some(function (item) { return item.toLowerCase() === String(code).toLowerCase(); });
        if (!exists) found.push(String(code));
      }
      (cart.discount_codes || []).forEach(function (item) { add(item && (item.code || item.title)); });
      (cart.cart_level_discount_applications || []).forEach(function (item) {
        if (item && item.type === 'discount_code') add(item.title);
      });
      return found;
    }

    function setPromotionCode(cart, shouldApply, forceRefresh) {
      var currentCodes = discountCodes(cart);
      var codes = currentCodes.filter(function (code) {
        return code.toLowerCase() !== gwp.discountCode.toLowerCase()
          && code.toLowerCase() !== 'hinok-hand-balm-80';
      });
      if (shouldApply && gwp.discountCode) codes.push(gwp.discountCode);
      if (!forceRefresh && codes.join(',').toLowerCase() === currentCodes.join(',').toLowerCase()) return Promise.resolve(cart);
      return request(routes.update, { discount: codes.join(',') }, null, null, true);
    }

    function removeGiftLines(cart) {
      var updates = {};
      giftLines(cart).forEach(function (item) { updates[item.key] = 0; });
      if (!Object.keys(updates).length) return Promise.resolve(cart);
      return request(routes.update, { updates: updates }, null, null, true);
    }

    function normalizeGift(cart) {
      var allowed = [];
      if (gwp.available) allowed.push(gwp.variant);
      if (gwp.fallbackAvailable) allowed.push(gwp.fallbackVariant);
      var kept = false;
      var updates = {};
      giftLines(cart).forEach(function (item) {
        if (item.properties._hinok_gwp !== gwp.marker || allowed.indexOf(parseInt(item.variant_id, 10)) === -1 || kept) {
          updates[item.key] = 0;
        } else {
          kept = true;
          if (item.quantity !== 1) updates[item.key] = 1;
        }
      });
      if (!Object.keys(updates).length) return Promise.resolve(cart);
      return request(routes.update, { updates: updates }, null, null, true);
    }

    function addManagedGift(variantId, cart) {
      return request(routes.add, {
        items: [{ id: variantId, quantity: 1, properties: { _hinok_gwp: gwp.marker } }]
      }, null, null, true).then(function () { return cart; });
    }

    function addGift(cart) {
      var variants = [
        { id: gwp.variant, available: gwp.available, priority: 'sample' },
        { id: gwp.fallbackVariant, available: gwp.fallbackAvailable, priority: 'retail' }
      ].filter(function (variant, index, list) {
        return variant.id && variant.available && list.findIndex(function (item) { return item.id === variant.id; }) === index;
      });
      function attempt(index) {
        if (index >= variants.length) {
          var unavailable = new Error('Complimentary gift unavailable');
          unavailable.gwpUnavailable = true;
          throw unavailable;
        }
        return addManagedGift(variants[index].id, cart).then(function (currentCart) {
          return { cart: currentCart, variantId: variants[index].id, priority: variants[index].priority };
        }).catch(function (err) {
          if (!err || err.cartStatus !== 422) throw err;
          return attempt(index + 1);
        });
      }
      return attempt(0);
    }

    function refreshGwpConfig() {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      return fetch(routes.cart.replace(/\.js$/, '') + '?section_id=cart-drawer', {
        headers: { Accept: 'text/html' }, cache: 'no-store', signal: controller.signal
      }).then(function (res) {
        if (!res.ok) throw new Error('Gift configuration request failed');
        return res.text();
      }).then(function (html) {
        if (html.indexOf('data-gwp-marker=') === -1) throw new Error('Invalid gift configuration');
        swapFromSectionHtml(html);
      }).finally(function () { clearTimeout(timeout); });
    }

    var giftUnavailable = false;
    var gwpSyncInFlight = null;
    function scheduleGwpSync(cart, configCurrent) {
      if (gwpSyncInFlight) return gwpSyncInFlight;
      gwpSyncInFlight = syncGwp(isCartSnapshot(cart) ? cart : null, configCurrent).finally(function () {
        try {
          if (pendingGiftSections) {
            renderCartSections(pendingGiftSections);
            pendingGiftSections = null;
            computeRecos();
            if (gwpErrorMessage) setGwpMessage(gwpErrorMessage);
          }
        } finally {
          gwpSyncInFlight = null;
          setGwpBusy(false);
        }
      });
      return gwpSyncInFlight;
    }

    function carePromotionCodes() {
      return [gwp.discountCode, drawer.dataset.gwpBodyDiscountCode, gwp.combinedCode, 'HINOK-DISCOVERY-90', 'HINOK-CARE-HAND-80', 'HINOK-HAND-BALM-80', 'HINOK-TO-GO-70', 'A-GIFT-FROM-HINOK-80', 'A-GIFT-FROM-HINOK-BODY-110', 'A-GIFT-FROM-HINOK-110'].filter(Boolean);
    }
    function setCarePromotionCode(cart, expected, forceRefresh) {
      var currentCodes = discountCodes(cart);
      var managedCodes = carePromotionCodes().map(function (code) { return code.toLowerCase(); });
      var codes = currentCodes.filter(function (code) { return managedCodes.indexOf(code.toLowerCase()) === -1; });
      var desired = careGifts.code(expected);
      if (desired) codes.push(desired);
      if (!forceRefresh && codes.join(',').toLowerCase() === currentCodes.join(',').toLowerCase()) return Promise.resolve(cart);
      return request(routes.update, { discount: codes.join(',') }, null, null, true);
    }
    function syncCareGwp(seedCart, attempt, configCurrent) {
      attempt = attempt || 0;
      if (!attempt) careUnavailableVariants.clear();
      readGwpConfig();
      var keepCheckoutLocked = false;
      var addedTiers = [];
      var expected = [];
      var deferredGiftSections = false;
      careGiftError = false;
      gwpErrorMessage = null;
      gwpCheckoutBlocked = false;
      setGwpBusy(true);
      return (seedCart ? Promise.resolve(seedCart) : (configCurrent ? getCart() : refreshGwpConfig().then(getCart))).then(function (cart) {
        var hasManagedGift = (cart.items || []).some(isManagedGift);
        var managedCodes = carePromotionCodes().map(function (code) { return code.toLowerCase(); });
        var hasManagedCode = discountCodes(cart).some(function (code) {
          return managedCodes.indexOf(code.toLowerCase()) !== -1;
        });
        // A cart permalink can replace the gift lines while retaining the old
        // gift code. Clear that orphaned code before it discounts a paid item
        // and lowers the qualifying subtotal. Keep unrelated customer codes.
        if (!hasManagedGift && hasManagedCode) return setCarePromotionCode(cart, []);
        return cart;
      }).then(function (cart) {
        var items = cart.items || [];
        var paidBeforeGift = items.some(function (gift, giftIndex) {
          return isManagedGift(gift) && items.some(function (item, index) {
            return !isManagedGift(item) && item.variant_id === gift.variant_id && index < giftIndex;
          });
        });
        if (!paidBeforeGift) return cart;
        return removeGiftLines(cart).then(function (state) { return setCarePromotionCode(state, []); });
      }).then(function (cart) {
        // Removing or replacing a gift can move its retained code onto a paid
        // item of the same product. Clear managed codes before that removal,
        // then recalculate eligibility from the clean paid lines below.
        var planned = careGifts.normalizeUpdates(cart, careGifts.fulfilment(careGifts.subtotal(cart)));
        var removesGift = Object.keys(planned).some(function (key) { return planned[key] === 0; });
        return removesGift ? setCarePromotionCode(cart, []) : cart;
      }).then(function (cart) {
        var subtotal = careGifts.subtotal(cart);
        drawer.dataset.gwpQualifyingTotal = subtotal;
        expected = careGifts.fulfilment(subtotal);
        var updates = careGifts.normalizeUpdates(cart, expected);
        deferredGiftSections = Object.keys(updates).length > 0 && expected.some(function (tier) {
          return !(cart.items || []).some(function (item) {
            return careGifts.tierFor(item)?.key === tier.key && updates[item.key] !== 0;
          });
        });
        var normalized = Object.keys(updates).length ? request(routes.update, { updates: updates }, null, null, true, deferredGiftSections) : Promise.resolve(cart);
        return normalized.then(function (currentCart) {
          var chain = Promise.resolve(currentCart);
          expected.forEach(function (tier) {
            chain = chain.then(function (state) {
              if ((state.items || []).some(function (item) { return careGifts.tierFor(item)?.key === tier.key; })) return state;
              setGwpMessage('qualifying');
              return request(routes.add, { items: [{ id: tier.variant, quantity: 1,
                properties: { _hinok_gwp: gwp.marker, _hinok_gwp_tier: tier.key } }] }, null, null, true)
                .then(function () { addedTiers.push(tier); return state; })
                .catch(function (error) {
                  if (error.cartStatus !== 422) throw error;
                  careUnavailableVariants.add(tier.variant);
                  error.giftStockRetry = true;
                  captureCartEvent('gwp_gift_unavailable', { gift_tier: tier.key, qualifying_subtotal_cents: subtotal });
                  throw error;
                });
            });
          });
          return chain;
        }).then(function (currentCart) {
          expected = careGifts.fulfilment(careGifts.subtotal(currentCart));
          return setCarePromotionCode(currentCart, expected, addedTiers.length > 0 || deferredGiftSections);
        }).then(function (discountedCart) {
          var currentExpected = careGifts.fulfilment(careGifts.subtotal(discountedCart));
          var signature = function (tiers) { return tiers.map(function (tier) { return tier.key + ':' + tier.variant; }).join(','); };
          if (signature(currentExpected) !== signature(expected) && attempt < 8) return syncCareGwp(discountedCart, attempt + 1, true);
          expected = currentExpected;
          if (!careGifts.valid(discountedCart, expected)) throw new Error('Care gift discount verification failed');
          drawer.dataset.gwpQualifyingTotal = careGifts.subtotal(discountedCart);
          updateCareMessage();
          addedTiers.forEach(function (tier) {
            captureCartEvent('gwp_gift_added', { gift_tier: tier.key, variant_id: tier.variant,
              qualifying_subtotal_cents: careGifts.subtotal(discountedCart), threshold_cents: tier.threshold });
          });
          if (Object.keys(updates).length) captureCartEvent('gwp_gift_removed', {
            reason: gwp.enabled ? 'tier_no_longer_eligible' : 'promotion_ended', qualifying_subtotal_cents: subtotal
          });
          computeRecos();
        });
      }).catch(function (error) {
        careGiftError = true;
        return getCart().then(removeGiftLines).then(function (cart) { return setCarePromotionCode(cart, [], deferredGiftSections); })
          .then(function (cleanCart) {
            if (error.giftStockRetry && attempt < 8) {
              careGiftError = false;
              readGwpConfig();
              return syncCareGwp(cleanCart, attempt + 1);
            }
            setGwpMessage('discount-error');
            captureCartEvent('gwp_discount_failed', { error: error.message, gift_tiers: expected.map(function (tier) { return tier.key; }) });
          }).catch(function (cleanupError) {
            keepCheckoutLocked = true;
            gwpCheckoutBlocked = true;
            setGwpMessage('discount-error');
            showError(drawer.getAttribute('data-gwp-message-discount-error'));
            console.warn('[cart] care gift cleanup failed:', cleanupError);
          });
      }).finally(function () { if (!keepCheckoutLocked) setGwpBusy(false); });
    }

    function syncGwp(seedCart, configCurrent) {
      gwpErrorMessage = null;
      if (gwp.tiered) return syncCareGwp(seedCart, 0, configCurrent);
      var managedGiftPresent = false;
      var addedGift = null;
      var keepCheckoutLocked = false;
      gwpCheckoutBlocked = false;
      setGwpBusy(true);

      giftUnavailable = false;
      return (seedCart ? Promise.resolve(seedCart) : (configCurrent ? getCart() : refreshGwpConfig().then(getCart))).then(function (cart) {
        managedGiftPresent = giftLines(cart).length > 0;
        var subtotal = qualifyingSubtotal(cart);
        drawer.setAttribute('data-gwp-qualifying-total', subtotal);

        if (!gwp.enabled || gwp.threshold <= 0 || subtotal < gwp.threshold) {
          var removedGift = managedGiftPresent;
          var cleanup = removedGift ? removeGiftLines(cart) : Promise.resolve(cart);
          return cleanup.then(function (cleanCart) { return setPromotionCode(cleanCart, false); }).then(function () {
            if (removedGift) {
              captureCartEvent('gwp_gift_removed', {
                reason: gwp.enabled ? 'below_threshold' : 'promotion_ended',
                qualifying_subtotal_cents: subtotal,
                threshold_cents: gwp.threshold
              });
            }
            return null;
          });
        }

        setGwpMessage('qualifying');
        return normalizeGift(cart).then(function (normalizedCart) {
          if (giftLines(normalizedCart).length) return { cart: normalizedCart, variantId: null, priority: 'existing' };
          return addGift(normalizedCart);
        }).then(function (result) {
          addedGift = result.variantId ? result : null;
          return setPromotionCode(result.cart, true, Boolean(addedGift));
        }).then(function (discountedCart) {
          var gifts = giftLines(discountedCart);
          var giftIsFree = gifts.length === 1 && gifts[0].quantity === 1 && gifts[0].final_line_price === 0;
          if (!giftIsFree) {
            var discountError = new Error('Complimentary gift discount was not applied');
            discountError.gwpDiscountFailed = true;
            throw discountError;
          }
          setGwpMessage('added');
          if (addedGift) {
            captureCartEvent('gwp_gift_added', {
              variant_id: addedGift.variantId,
              gift_priority: addedGift.priority,
              gift_sku: addedGift.priority === 'sample' ? 'SS-SPR-100ML-TGO' : 'SPR-100ML-TGO',
              qualifying_subtotal_cents: qualifyingSubtotal(discountedCart),
              threshold_cents: gwp.threshold
            });
          }
          return null;
        });
      }).catch(function (err) {
        if (!gwp.enabled) {
          keepCheckoutLocked = true;
          gwpCheckoutBlocked = true;
          showError(drawer.getAttribute('data-error-generic'));
          throw err;
        }
        var messageType = err && err.gwpUnavailable ? 'unavailable' : 'discount-error';
        var eventName = err && err.gwpUnavailable ? 'gwp_gift_unavailable' : 'gwp_discount_failed';
        // An add can succeed even if its response is lost. Re-read before cleanup.
        var cleanup = getCart().then(removeGiftLines).then(function (cart) { return setPromotionCode(cart, false); });

        return cleanup.then(function () {
          giftUnavailable = Boolean(err && err.gwpUnavailable);
          setGwpMessage(messageType);
          captureCartEvent(eventName, {
            threshold_cents: gwp.threshold,
            error: err && err.message
          });
        }).catch(function (cleanupError) {
          keepCheckoutLocked = true;
          gwpCheckoutBlocked = true;
          setGwpMessage('discount-error');
          showError(drawer.getAttribute('data-gwp-message-discount-error'));
          console.warn('[cart] gift cleanup failed:', cleanupError);
        });
      }).finally(function () {
        if (!keepCheckoutLocked) setGwpBusy(false);
      });
    }

    var checkoutInProgress = false;
    function promotionCodeApplied(cart) {
      return discountCodes(cart).some(function (code) {
        return code.toLowerCase() === gwp.discountCode.toLowerCase();
      });
    }

    function checkoutRequirementsMet(cart) {
      if (gwp.tiered) {
        var expected = careGifts.fulfilment(careGifts.subtotal(cart));
        var desired = careGifts.code(expected).toLowerCase();
        var applied = discountCodes(cart).filter(function (code) {
          return carePromotionCodes().some(function (managed) { return managed.toLowerCase() === code.toLowerCase(); });
        });
        return careGifts.valid(cart, expected) && (desired ? applied.length === 1 && applied[0].toLowerCase() === desired : applied.length === 0);
      }
      var gifts = giftLines(cart);
      if (!gwp.enabled || giftUnavailable || gwp.threshold <= 0) return gifts.length === 0 && !promotionCodeApplied(cart);
      if (qualifyingSubtotal(cart) < gwp.threshold) {
        return gifts.length === 0 && !promotionCodeApplied(cart);
      }
      return gifts.length === 1
        && gifts[0].properties._hinok_gwp === gwp.marker
        && [gwp.variant, gwp.fallbackVariant].indexOf(parseInt(gifts[0].variant_id, 10)) !== -1
        && gifts[0].quantity === 1
        && gifts[0].final_line_price === 0
        && promotionCodeApplied(cart);
    }

    function proceedToCheckout() {
      if (checkoutInProgress) return;
      checkoutInProgress = true;
      try { cartSnapshotRecheck.cancel(); } catch (_) {}
      clearError();
      var checkoutStage = 'gift_sync';
      setGwpBusy(true);
      return queue.then(function () { return scheduleGwpSync(); })
        .then(function () {
          setGwpBusy(true);
          checkoutStage = 'cart_read';
          return getCart();
        })
        .then(function (cart) {
          checkoutStage = 'subscription_validation';
          var subscriptionMessage = window.HinokRefillSubscription && window.HinokRefillSubscription.issue(cart);
          if (subscriptionMessage) {
            var subscriptionError = new Error(subscriptionMessage);
            subscriptionError.subscriptionIssue = true;
            throw subscriptionError;
          }
          checkoutStage = 'validation';
          if (!checkoutRequirementsMet(cart)) {
            var checkoutError = new Error('Complimentary gift verification failed');
            checkoutError.gwpCheckoutBlocked = true;
            throw checkoutError;
          }
          checkoutStage = 'email_metadata';
          return prepareCheckoutMail(cart).then(function () {
          checkoutStage = 'tracking_sync';
          return new Promise(function (resolve) {
            var trackingTimer = window.setTimeout(resolve, 800);
            Promise.resolve().then(function () {
              if (typeof window.hinokSyncCartTracking === 'function') {
                return window.hinokSyncCartTracking({ force: true, timeoutMs: 700 });
              }
            }).catch(function () {}).then(function () {
              window.clearTimeout(trackingTimer);
              resolve();
            });
          }).then(function () {
            window.location.assign('/checkout');
          });
          });
        })
        .catch(function (err) {
          setGwpMessage(err && err.gwpUnavailable ? 'unavailable' : 'discount-error');
          showError(err && err.subscriptionIssue ? err.message : drawer.getAttribute(gwp.enabled ? 'data-gwp-message-discount-error' : 'data-error-generic'));
          captureCartEvent('gwp_checkout_blocked', {
            threshold_cents: gwp.threshold,
            error: err && err.message,
            stage: (err && err.cartStage) || checkoutStage,
            status: (err && err.cartStatus) || null,
            read_attempts: (err && err.cartReadAttempts) || null
          });
        })
        .finally(function () {
          checkoutInProgress = false;
          setGwpBusy(false);
        });
    }

    /* Public hook — any surface (PDP buy block, quick-add, etc.) can add a
       SPECIFIC variant and open the drawer:
         document.dispatchEvent(new CustomEvent('cart:add', {detail:{id, quantity, handle}}))
       Unlike the .product-card__atc handler (which resolves the first available
       variant), this respects the caller's exact variant id. A 'cart:add:done'
       event (detail.ok) is dispatched back so the trigger can re-enable itself. */
    function refreshJourneyCart() {
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      return fetch(routes.cart.replace(/\.js$/, '') + '?section_id=cart-drawer', { cache: 'no-store', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed');
          return response.text();
        })
        .then(function (html) {
          if (!new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]')) throw new Error('Cart section missing');
          swapFromSectionHtml(html);
          computeRecos();
        })
        .finally(function () { clearTimeout(timeout); });
    }
    document.addEventListener('cart:add', function (e) {
      var d = (e && e.detail) || {};
      function done(ok, error, reconciled) {
        document.dispatchEvent(new CustomEvent('cart:add:done', {
          detail: { ok: ok, id: d.id || null, requestId: d.requestId, error: error, reconciled: reconciled }
        }));
      }
      if (!d.id) { done(false); return; }
      var isSelection = Array.isArray(d.items);
      var operation = isSelection
        ? request(routes.add, { items: d.items }, d.handle, showAddedCart)
        : addToCart(d.id, d.quantity || 1, d.handle, null, d.properties);
      operation.then(function () {
        open(true);
        done(true);
      }).catch(function (err) {
        if (!isSelection) { open(); fail(err); done(false); return; }
        refreshJourneyCart().then(function () { return scheduleGwpSync(); })
          .then(function () { open(); fail(err); done(false, err.message, true); })
          .catch(function () { open(); fail(err); done(false, drawer.getAttribute('data-journey-uncertain'), false); });
      });
    });

    /* Sold-out PLP/search cards → swap the ATC bar for the inert gray bar
       (product-card.liquid renders both; .is-soldout flips them). Live-domain
       gate mirrors the PDP BIS swap: the myshopify preview renders a non-US
       market context where every variant reads sold-out (see product.liquid),
       so preview keeps the ATC; force with ?bis-preview=1. */
    if (window.location.hostname === 'hinok.us' || window.location.search.indexOf('bis-preview') > -1) {
      Array.prototype.slice.call(document.querySelectorAll('.product-card[data-card-soldout]')).forEach(function (card) {
        card.classList.add('is-soldout');
      });
    }

    /* --- Global triggers: header cart links + product-card add-to-cart --- */
    document.addEventListener('click', function (e) {
      var checkout = e.target.closest('[data-gwp-checkout]');
      if (checkout) {
        if (checkout.closest('[data-gwp-checkout-form]')) return;
        e.preventDefault();
        proceedToCheckout();
        return;
      }
      var opener = e.target.closest('[data-cart-open]');
      if (opener) {
        e.preventDefault();
        open();
        return;
      }
      /* fs-card__atc (home feature slider) carries its own /products/ href —
         intercept for a real add-to-cart; without JS the href is the fallback. */
      var atc = e.target.closest('.product-card__atc, .fs-card__atc');
      if (atc) {
        if (atc.hasAttribute('data-b2b-portal-cta')) return;
        var card = atc.closest('.product-card');
        var link = card && card.querySelector('.product-card__media-link');
        var href = (link || atc).getAttribute('href') || '';
        var match = href.match(/\/products\/([^/?#]+)/);
        if (!match) {
          console.warn('[cart] ATC control has no /products/ link to resolve');
          return;
        }
        e.preventDefault();
        atc.disabled = true;
        fetch('/products/' + match[1] + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('product fetch ' + r.status);
            return r.json();
          })
          .then(function (p) {
            var available = (p.variants || []).filter(function (v) { return v.available; });
            var variant = available[0] || (p.variants && p.variants[0]);
            if (!variant) throw new Error('no variant');
            return addToCart(variant.id, 1, match[1]);
          })
          .then(function () { open(); })
          .catch(function (err) {
            open(); // surface the failure inside the drawer
            fail(err);
          })
          .finally(function () { atc.disabled = false; });
      }
    });


    window.installHinokCartPageMutations({
      routes: routes,
      request: request,
      isBusy: function () { return Boolean(pendingCartMutations || gwpSyncInFlight || checkoutInProgress); },
      onError: function (error, form) {
        var message = form && form.querySelector('[data-gwp-checkout-error]');
        if (message) { message.textContent = drawer.dataset.errorGeneric || error.message; message.hidden = false; }
        fail(error);
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-gwp-checkout-form]');
      if (!form || !e.submitter || e.submitter.name !== 'checkout') return;
      e.preventDefault();
      var inputs = Array.prototype.slice.call(form.querySelectorAll('[name="updates[]"]'));
      var changed = inputs.some(function (input) { return input.value !== input.defaultValue; });
      if (changed) {
        var updates = window.HinokCartLineGroups.formUpdates(form);
        request(routes.update, { updates: updates }).then(proceedToCheckout).catch(fail);
      } else {
        proceedToCheckout();
      }
    });

    /* --- In-drawer interactions (delegated; regions get swapped out) --- */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      /* Desktop: clicking the dimmed backdrop (outside the panel) closes. On
         mobile the panel fills the screen, so this never fires there. */
      if (!e.target.closest('.cart-drawer__panel')) { close(); return; }

      var tab = e.target.closest('[data-cart-tab]');
      if (tab) {
        var name = tab.getAttribute('data-cart-tab');
        Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-tab]')).forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        Array.prototype.slice.call(drawer.querySelectorAll('[data-cart-tabpanel]')).forEach(function (p) {
          p.hidden = p.getAttribute('data-cart-tabpanel') !== name;
        });
        computeRecos();
        return;
      }

      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var delta = parseInt(step.getAttribute('data-qty-step'), 10);
        var recoRow = step.closest('[data-reco]');
        if (recoRow) {
          /* "+" adds straight to the cart (Ruben 2026-07-10 — the old
             Add-to-cart text is gone); the refresh then swaps the reco row
             for a real line via dedupe. Guard double-taps until it lands. */
          if (delta > 0 && !recoRow.hasAttribute('data-adding')) {
            recoRow.setAttribute('data-adding', '');
            var recoVariant = parseInt(recoRow.getAttribute('data-variant-id'), 10);
            if (recoVariant) {
              var recoSlot = parseInt(recoRow.getAttribute('data-reco-slot'), 10) || null;
              var recoEventProps = recommendationProps(
                activeRecoContext.handle,
                activeRecoContext.method,
                recoRow,
                recoSlot
              );
              addToCart(recoVariant, 1, null, function () {
                captureCartEvent('minicart_reco_add', recoEventProps);
              }).then(function () {
                recoRow.removeAttribute('data-adding');
              }, function (err) {
                recoRow.removeAttribute('data-adding');
                fail(err, recoRow);
              });
            } else {
              recoRow.removeAttribute('data-adding');
            }
          }
        } else {
          var lineRow = step.closest('[data-key]');
          if (lineRow) {
            var qty = Math.max(0, parseInt(lineRow.getAttribute('data-quantity'), 10) + delta);
            changeLine(lineRow, qty).catch(function (err) { fail(err, lineRow); });
          }
        }
        return;
      }

      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        var row = removeBtn.closest('[data-key]');
        if (row) {
          changeLine(row, 0).catch(function (err) { fail(err, row); });
        }
        return;
      }

    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden && !document.querySelector('[data-care-gift-dialog][open]')) close();
    });

    /* Theme editor: selecting the Cart drawer section opens it so the
       design-preview items can actually be seen. */
    /* Initial reveal — tab A's candidates all render hidden, so this first
       pass reveals the anchor's cross-sell set (the _empty trio on an empty cart)
       and syncs tab B's dedupe. Also covers the design-preview fake items
       (whose in-cart twins the server can't know about). */
    computeRecos();
    if (gwp.tiered && (Number(drawer.dataset.gwpGiftCount) > 0 || Number(drawer.dataset.gwpQualifyingTotal) >= gwp.threshold)) {
      scheduleGwpSync().catch(fail);
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.querySelector && e.target.querySelector('#cart-drawer')) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.querySelector && e.target.querySelector('#cart-drawer')) close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.collection__pills').forEach(function (pills) {
      var active = pills.querySelector('.is-active');
      if (!active) return;
      /* The BAR is the scroll container (overflow-x lives on .collection__tabsbar,
         not on the nav) — the earlier version scrolled the nav and did nothing.
         Always center the active tab in the device viewport (Ruben 2026-07-10);
         the browser clamps scrollLeft, so end tabs land flush and Shop all
         stays put. Rect-based math so offsetParent chains can't skew it. */
      var bar = pills.closest('.collection__tabsbar') || pills;
      var scroller = bar.scrollWidth > bar.clientWidth ? bar : pills;
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      requestAnimationFrame(function () {
        var rect = active.getBoundingClientRect();
        var srect = scroller.getBoundingClientRect();
        var target = scroller.scrollLeft + (rect.left - srect.left) - (srect.width - rect.width) / 2;
        scroller.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.feature-slider').forEach(function (section) {
      var track = section.querySelector('.feature-slider__track');
      var cards = Array.prototype.slice.call(section.querySelectorAll('.fs-card'));
      var bgs = Array.prototype.slice.call(section.querySelectorAll('.feature-slider__bg'));
      if (!track || cards.length < 2) return;

      // Desktop (≥990): the track is a static grid — hover/focus/pager drive the
      // active card instead of scroll position.
      var mqDesktop = window.matchMedia('(min-width: 990px)');
      var pagerCurrent = section.querySelector('[data-pager-current]');
      /* Only per-card intros carry data-intro; a persistent heading has none and is left as-is. */
      var intros = Array.prototype.slice.call(section.querySelectorAll('.feature-slider__intro[data-intro]'));
      var activeIdx = 0;

      var setActive = function (idx) {
        activeIdx = idx;
        cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
        bgs.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
        // Show the active card's intro (each carries its own text + light/dark);
        // it crossfades in as the background swaps.
        intros.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-intro') === String(idx)); });
        if (pagerCurrent) pagerCurrent.textContent = idx + 1;
      };
      // Distance between consecutive card starts (card width + gap).
      var step = function () {
        return cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : track.clientWidth;
      };
      // Resolve the active card from where the scroll landed — native mandatory
      // snap (+ scroll-snap-stop: always) does the threshold paging; we only read
      // the result AFTER it settles so the card/background don't flicker mid-drag.
      var update = function () {
        if (mqDesktop.matches) return; // desktop grid never scrolls
        var s = step();
        if (!s) return;
        var idx = Math.round(track.scrollLeft / s);
        idx = Math.max(0, Math.min(cards.length - 1, idx));
        setActive(idx);
      };

      // Desktop: hovering or tabbing into a card makes it active (bg crossfades).
      cards.forEach(function (c, i) {
        c.addEventListener('mouseenter', function () {
          if (mqDesktop.matches) setActive(i);
        });
        c.addEventListener('focusin', function () {
          if (mqDesktop.matches) setActive(i);
        });
      });

      // Desktop: only 3 cards fit the clipped track — slide the active card
      // fully into view when the pager reaches one past the edge.
      var revealCard = function (idx) {
        if (!mqDesktop.matches) return;
        var c = cards[idx];
        var tRect = track.getBoundingClientRect();
        var cRect = c.getBoundingClientRect();
        var left = cRect.left - tRect.left + track.scrollLeft;
        var target = track.scrollLeft;
        if (left + cRect.width > track.scrollLeft + track.clientWidth) target = left + cRect.width - track.clientWidth;
        else if (left < track.scrollLeft) target = left;
        if (Math.abs(target - track.scrollLeft) > 1) track.scrollTo({ left: target, behavior: 'smooth' });
      };

      // Desktop pager arrows step the active card (wrapping).
      Array.prototype.slice.call(section.querySelectorAll('[data-pager-dir]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-pager-dir'), 10) || 1;
          var next = (activeIdx + dir + cards.length) % cards.length;
          setActive(next);
          revealCard(next);
        });
      });

      var settle;
      var onScroll = function () {
        clearTimeout(settle);
        settle = setTimeout(update, 100);
      };
      // Prefer the precise scrollend event where supported; debounce as fallback.
      if ('onscrollend' in window) {
        track.addEventListener('scrollend', update);
      } else {
        track.addEventListener('scroll', onScroll, { passive: true });
      }
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-refill-steps"] && !Shopify.designMode) return;
  try {
    
  /* Desktop hover-swap (the guide-rooms grammar) + in-viewport video play.
     Thumbs are plain product links; the last hovered stays active. Videos are
     decorative 4s loops: play only while on screen, never under
     prefers-reduced-motion (the poster holds the frame). */
  document.querySelectorAll('[data-guide-rsteps]').forEach(function (root) {
    root.querySelectorAll('[data-picker]').forEach(function (picker) {
      var picks = Array.prototype.slice.call(picker.querySelectorAll('[data-pick]'));
      var panels = Array.prototype.slice.call(picker.querySelectorAll('[data-panel]'));
      if (picks.length < 2 || picks.length !== panels.length) return;
      picks.forEach(function (pick, i) {
        function activate() {
          picks.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
          panels.forEach(function (el, j) { el.hidden = j !== i; });
        }
        pick.addEventListener('mouseenter', activate);
        pick.addEventListener('focus', activate);
      });
    });
    root.querySelectorAll('[data-step-video]').forEach(function (video) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      function play() {
        if (reduce.matches) return;
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (!('IntersectionObserver' in window)) { play(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { play(); }
          else if (!video.paused) { video.pause(); }
        });
      }, { threshold: 0.2 });
      io.observe(video);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-rooms"] && !Shopify.designMode) return;
  try {
    
  /* Desktop hover-swap: moving the pointer over (or focusing) a thumbnail
     shows that product's title+line in the column's panel and moves the
     cypress outline. The last hovered thumb stays active on pointer-leave.
     Thumbs are plain product links — click/tap navigates, so mobile and
     no-JS lose nothing (mobile renders the full list anyway). */
  document.querySelectorAll('[data-guide-rooms] [data-picker]').forEach(function (picker) {
    var picks = Array.prototype.slice.call(picker.querySelectorAll('[data-pick]'));
    var panels = Array.prototype.slice.call(picker.querySelectorAll('[data-panel]'));
    if (picks.length < 2 || picks.length !== panels.length) return;
    picks.forEach(function (pick, i) {
      function activate() {
        picks.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
        panels.forEach(function (el, j) { el.hidden = j !== i; });
      }
      pick.addEventListener('mouseenter', activate);
      pick.addEventListener('focus', activate);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide-steps"] && !Shopify.designMode) return;
  try {
    
  /* Desktop slider: INFINITE loop. Step columns (copy+media pairs) are cloned on
     both sides, so next/prev roll continuously (…4,5,1,2… / …2,1,5,4…). Once a
     scroll settles, the position snaps back into the real+buffer band — invisible
     because the clones are identical. Mobile (<990) is a plain stack: clones are
     hidden via CSS ([data-clone]) and no scroll math runs. */
  document.querySelectorAll('[data-guide-steps]').forEach(function (root) {
    var track = root.querySelector('[data-steps-track]');
    var pager = root.querySelector('[data-steps-pager]');
    if (!track || !pager) return;
    var count = pager.querySelector('[data-steps-count]');
    var prev = pager.querySelector('[data-steps-prev]');
    var next = pager.querySelector('[data-steps-next]');
    var mq = window.matchMedia('(min-width: 990px)');

    var total = track.querySelectorAll('[data-step-copy]').length;
    if (total < 2) return;
    var originalChildren = Array.prototype.slice.call(track.children); /* copy0,media0,copy1,media1,… */
    var SETS = 3;                    /* clone sets each side — matches the reviews buffer */
    var realStart = SETS * total;    /* index (in the copies list) of the first REAL step */
    var built = false;

    function mkClone(node) {
      var c = node.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-clone', '');
      Array.prototype.slice.call(c.querySelectorAll('a')).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      return c;
    }
    function build() {
      if (built) return;
      for (var s = 0; s < SETS; s++) {
        originalChildren.forEach(function (n) { track.appendChild(mkClone(n)); });
      }
      for (var s2 = 0; s2 < SETS; s2++) {
        for (var i = originalChildren.length - 1; i >= 0; i--) {
          track.insertBefore(mkClone(originalChildren[i]), track.firstChild);
        }
      }
      built = true;
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }
    function copies() { return Array.prototype.slice.call(track.querySelectorAll('[data-step-copy]')); }
    function unit() {
      var cs = copies();
      return (cs.length > 1) ? (cs[1].offsetLeft - cs[0].offsetLeft) : track.clientWidth;
    }
    function leftIndex() {
      var u = unit();
      return u > 0 ? Math.round(track.scrollLeft / u) : realStart;
    }
    function realOffset(i) { return (((i - realStart) % total) + total) % total; }
    function center() {
      var u = unit();
      if (u > 0) track.scrollLeft = realStart * u;
    }
    function updateCount() {
      if (count) count.textContent = (realOffset(leftIndex()) + 1) + ' / ' + total;
    }
    function recenter() {
      var u = unit();
      if (u <= 0) return;
      var i = leftIndex();
      var target = realStart + realOffset(i);
      if (i !== target) track.scrollLeft = target * u;
    }
    function stepBy(dir) {
      track.scrollTo({ left: track.scrollLeft + dir * unit(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { if (mq.matches) stepBy(-1); });
    if (next) next.addEventListener('click', function () { if (mq.matches) stepBy(1); });

    var settle;
    track.addEventListener('scroll', function () {
      if (!mq.matches) return;
      updateCount();
      clearTimeout(settle);
      settle = setTimeout(recenter, 140);
    }, { passive: true });

    function setup() {
      if (mq.matches) {
        build();
        pager.hidden = false;
        requestAnimationFrame(function () { center(); updateCount(); });
      } else {
        pager.hidden = true;
      }
    }
    mq.addEventListener ? mq.addEventListener('change', setup) : mq.addListener(setup);
    window.addEventListener('resize', function () { if (mq.matches) center(); });
    setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-sticky-header].site-header--overlay');
    if (!header) return;
    var ticking = false, galleryStuck = false;
    /* PDP: the bar keeps the frosted-glass state from load — it floats as a
       layer over the gallery stage instead of starting transparent (Ruben
       2026-07-10, Koppen grammar). */

    var apply = function () {
      header.classList.toggle('is-stuck', window.scrollY > 40 || galleryStuck);
      ticking = false;
    };
    apply();
    var onScroll = function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(apply);
      }
    };
    /* PDP hero gallery: from the 2nd image on, the varying photo backgrounds can
       swallow the transparent logo/menu — so paint the frosted bar (same as the
       scrolled state). product.liquid dispatches pdp:gallery-index on horizontal
       gallery scroll; index >= 1 (2nd image on) sticks the bar even at scrollY 0. */
    document.addEventListener('pdp:gallery-index', function (e) {
      galleryStuck = ((e.detail && e.detail.index) || 0) >= 1;
      apply();
    });
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* Desktop mega-menu — hover / keyboard-focus to open, Esc + focus-leave to close */
  (function () {
    var header = document.querySelector('.site-header[data-sticky-header]');
    if (!header) return;
    var items = Array.prototype.slice.call(header.querySelectorAll('[data-mega-item]'));
    if (!items.length) return;
    var panels = {};
    Array.prototype.slice.call(header.querySelectorAll('[data-mega-panel]')).forEach(function (p) {
      p.hidden = false; // CSS visibility owns the hidden state so the fade can run
      panels[p.getAttribute('data-mega-panel')] = p;
    });
    var closeTimer = null;
    var openName = null;
    var open = function (name) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openName === name) return;
      openName = name;
      Object.keys(panels).forEach(function (k) { panels[k].classList.toggle('is-open', k === name); });
      items.forEach(function (it) {
        var t = it.querySelector('[data-mega-toggle]');
        if (t) t.setAttribute('aria-expanded', it.getAttribute('data-mega-item') === name ? 'true' : 'false');
      });
      header.classList.add('is-mega-open');
    };
    var close = function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      openName = null;
      Object.keys(panels).forEach(function (k) { panels[k].classList.remove('is-open'); });
      items.forEach(function (it) { var t = it.querySelector('[data-mega-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); });
      header.classList.remove('is-mega-open');
    };
    var scheduleClose = function () {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 160);
    };

    items.forEach(function (it) {
      var name = it.getAttribute('data-mega-item');
      it.addEventListener('mouseenter', function () { open(name); });
      it.addEventListener('mouseleave', scheduleClose);
      it.addEventListener('focusin', function () { open(name); });
    });
    Object.keys(panels).forEach(function (name) {
      var p = panels[name];
      p.addEventListener('mouseenter', function () { open(name); });
      p.addEventListener('mouseleave', scheduleClose);
    });
    // Hovering a non-trigger bar item (logo, About, Account, Cart) dismisses the menu.
    Array.prototype.slice.call(header.querySelectorAll('.site-header__logo, .site-header__actions, .site-header__nav > .site-header__navlink')).forEach(function (el) {
      el.addEventListener('mouseenter', scheduleClose);
    });
    // Keyboard: closing when focus leaves the whole header.
    header.addEventListener('focusout', function (e) {
      if (!header.contains(e.relatedTarget)) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openName) close(); });
  })();

  /* Mobile nav drawer — open/close + drilldown view switching */
  (function () {
    var drawer = document.getElementById('nav-drawer');
    if (!drawer) return;
    var panel = drawer.querySelector('.nav-drawer__panel');
    var scroller = drawer.querySelector('.nav-drawer__scroll');
    var closeBtn = drawer.querySelector('[data-nav-close]');
    var backBtn = drawer.querySelector('[data-nav-back]');
    var views = Array.prototype.slice.call(drawer.querySelectorAll('.nav-drawer__view'));
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-nav-open]'));
    var hideTimer = null;
    var lastFocus = null;

    var subhead = drawer.querySelector('[data-nav-subhead]');
    var subTitle = drawer.querySelector('[data-nav-title]');
    var setView = function (name) {
      // Toggling [hidden] (display:none -> block) re-runs each view's CSS bloom.
      var active = null;
      views.forEach(function (v) {
        var match = v.getAttribute('data-view') === name;
        v.hidden = !match;
        if (match) active = v;
      });
      var atRoot = name === 'root';
      if (subhead) {
        subhead.hidden = atRoot;
        if (subTitle) subTitle.textContent = (active && active.getAttribute('data-view-title')) || '';
      }
      panel.setAttribute('data-nav-state', name);
      if (scroller) scroller.scrollTop = 0;
    };

    var open = function () {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      lastFocus = document.activeElement;
      drawer.hidden = false;
      setView('root');
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      closeBtn.focus();
    };
    var close = function () {
      // Guard against repeats (ESC auto-repeat / double-tap): a second call used
      // to queue an orphaned timer that hid the drawer after it was reopened.
      if (!drawer.classList.contains('is-open')) return;
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      hideTimer = setTimeout(function () {
        drawer.hidden = true;
        hideTimer = null;
      }, 420);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    /* aria-modal promises containment — wrap Tab inside the panel (WCAG 2.4.3) */
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || drawer.hidden) return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    openers.forEach(function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    closeBtn.addEventListener('click', close);
    backBtn.addEventListener('click', function () { setView('root'); });
    Array.prototype.slice.call(drawer.querySelectorAll('[data-drill]')).forEach(function (d) {
      var pending = null;
      d.addEventListener('click', function () {
        if (pending) return;
        // Let the underline sweep read before the swap hides the row.
        var wait = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
        pending = setTimeout(function () { pending = null; setView(d.getAttribute('data-drill')); }, wait);
      });
    });

    // Tap feedback: restartable one-shot underline sweep (see the CSS note —
    // press-state styles alone are invisible on a quick tap).
    Array.prototype.slice.call(drawer.querySelectorAll('.nav-drawer__row')).forEach(function (row) {
      var sweep = function () {
        row.classList.remove('is-pressed');
        void row.offsetWidth; // restart the animation on rapid re-taps
        row.classList.add('is-pressed');
      };
      row.addEventListener('pointerdown', sweep);
      row.addEventListener('click', function (e) { if (e.detail === 0) sweep(); }); // keyboard activation
      row.addEventListener('animationend', function () { row.classList.remove('is-pressed'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.press').forEach(function (section) {
      var track = section.querySelector('[data-press-track]');
      var slides = Array.prototype.slice.call(section.querySelectorAll('.press-slide'));
      var count = section.querySelector('[data-press-count]');
      var prev = section.querySelector('[data-press-prev]');
      var next = section.querySelector('[data-press-next]');
      if (!track || slides.length < 2) return;
      var total = slides.length;
      var current = 0;
      // One step = slide width + gap: a full slide on mobile, one column on desktop.
      var step = function () { return slides[1].offsetLeft - slides[0].offsetLeft; };
      var maxIndex = function () {
        var s = step();
        return s ? Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / s)) : 0;
      };
      // Count scroll positions, not slides: mobile has one per slide; desktop
      // (three in view) has total - 2, so the counter ends on N/N.
      var update = function () {
        var s = step();
        current = s ? Math.round(track.scrollLeft / s) : 0;
        if (count) count.textContent = (current + 1) + '/' + (maxIndex() + 1);
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      // Wraps at both ends so autoplay loops back to the first slide.
      var go = function (idx) {
        var m = maxIndex();
        if (idx > m) idx = 0;
        if (idx < 0) idx = m;
        track.scrollTo({ left: idx * step(), behavior: 'smooth' });
      };

      // Autoplay: pauses on hover, keyboard focus, off-screen, hidden tab and
      // reduced motion; any manual swipe or arrow click restarts the delay.
      var delay = parseInt(section.getAttribute('data-press-autoplay'), 10);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var timer = null, hovered = false, focused = false, inView = false;
      var stop = function () { clearInterval(timer); timer = null; };
      var start = function () {
        stop();
        if (!delay || reduce.matches || hovered || focused || !inView || document.hidden || maxIndex() === 0) return;
        timer = setInterval(function () { go(current + 1); }, delay);
      };
      if (delay) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          start();
        }, { threshold: 0.25 }).observe(section);
        section.addEventListener('mouseenter', function () { hovered = true; stop(); });
        section.addEventListener('mouseleave', function () { hovered = false; start(); });
        section.addEventListener('focusin', function (e) {
          if (e.target.matches(':focus-visible')) { focused = true; stop(); }
        });
        section.addEventListener('focusout', function () { focused = false; start(); });
        track.addEventListener('touchstart', start, { passive: true });
        document.addEventListener('visibilitychange', start);
        window.addEventListener('resize', start);
      }

      if (prev) prev.addEventListener('click', function () { go(current - 1); start(); });
      if (next) next.addEventListener('click', function () { go(current + 1); start(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-facts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp-howto]').forEach(function (root) {
      var frames = root.querySelectorAll('[data-howto-frame]');
      var steps = root.querySelectorAll('[data-howto-step]');
      var thumbs = root.querySelectorAll('[data-howto-thumb]');
      function show(i) {
        frames.forEach(function (f) { f.classList.toggle('is-active', +f.getAttribute('data-howto-frame') === i); });
        steps.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-howto-step') === i); });
        thumbs.forEach(function (t) {
          var on = +t.getAttribute('data-howto-thumb') === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-howto-thumb')); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var API = 'https://storefront-api.loox.io/storefront/v1/store/';
    var STAR = '<svg class="pdp-star" viewBox="0 0 12.84 10.17" aria-hidden="true" focusable="false"><path d="M6.41982 0L7.86115 3.88372H12.5254L8.75195 6.28399L10.1933 10.1677L6.41982 7.76744L2.64634 10.1677L4.08768 6.28399L0.314208 3.88372H4.97848L6.41982 0Z"/></svg>';
    var VERIFIED = '<svg class="pdp-review__verified" viewBox="0 0 16 16" aria-label="Verified" role="img"><circle cx="8" cy="8" r="8" fill="var(--color-cypress)"/><path d="M4.6 8.2l2.1 2.1 4.6-4.6" fill="none" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function starsHtml(rating) {
      var r = Math.round(rating || 0), h = '';
      for (var i = 0; i < 5; i++) h += '<span class="pdp-review__star' + (i < r ? ' is-full' : '') + '">' + STAR + '</span>';
      return h;
    }
    function fmtDate(iso) {
      var d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      return d.getFullYear() + '. ' + (d.getMonth() + 1) + '. ' + d.getDate();
    }
    function photoOf(rv) {
      return ((rv && rv.media) || []).filter(function (m) { return m && m.type === 'photo' && m.url; })[0] || null;
    }

    document.querySelectorAll('[data-pdp-reviews]').forEach(function (root) {
      var storeId = root.getAttribute('data-loox-store-id');
      var ids = (root.getAttribute('data-loox-product-ids') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var isBundle = root.hasAttribute('data-bundle-reviews');
      ids = Array.from(new Set(ids));
      var pinnedIds = Array.from(new Set((root.getAttribute('data-pinned-review-ids') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)));
      var sprayIds = (root.getAttribute('data-spray-review-ids') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var sprayName = root.getAttribute('data-spray-review-name');
      var listEl = root.querySelector('[data-reviews-list]');
      var emptyEl = root.querySelector('[data-reviews-empty]');
      var errorEl = root.querySelector('[data-reviews-error]');
      var retryBtn = root.querySelector('[data-reviews-retry]');
      var moreBtn = root.querySelector('[data-reviews-more]');
      var cardTpl = root.querySelector('[data-review-card-tpl]');
      var modal = root.querySelector('[data-review-modal]');
      var sortSel = root.querySelector('[data-reviews-sort]');
      var sortLabel = root.querySelector('[data-sort-label]');
      var replyLabel = root.getAttribute('data-reply-label') || '';
      var deskMq = window.matchMedia('(min-width: 990px)');
      var visible = parseInt(root.getAttribute(deskMq.matches ? 'data-visible-desktop' : 'data-visible') || '3', 10);
      var STEP = 5;

      if (!storeId || !ids.length || !listEl || !cardTpl) { if (listEl) listEl.setAttribute('aria-busy', 'false'); return; }
      var base = API + encodeURIComponent(storeId) + '/product-reviews';

      var sort = 'featured', members, buffer, seen, shown, renderedIds;
      var generation = 0, listFailed = false, summaryFailed = false;

      function reviewProductName(rv) {
        if (sprayName && rv.product && sprayIds.indexOf(String(rv.product.id)) !== -1) return sprayName;
        return ((rv.product && rv.product.name) || '').replace(/^\s*\[sample\]\s*/i, '');
      }
      function fetchPinnedReviews() {
        if (sort !== 'featured') return Promise.resolve([]);
        return Promise.all(pinnedIds.map(function (id) {
          return fetch(base + '/' + encodeURIComponent(id)).then(function (response) {
            if (response.status === 404) return null;
            if (!response.ok) throw new Error('Pinned review unavailable');
            return response.json();
          }).then(function (data) {
            if (!data) return null;
            var review = data.review;
            if (!review || review.id !== id || !review.product) throw new Error('Invalid pinned review');
            return ids.indexOf(String(review.product.id)) !== -1 ? review : null;
          });
        })).then(function (reviews) { return reviews.filter(Boolean); });
      }
      function reset() {
        generation++;
        listFailed = false;
        members = ids.map(function (id) { return { id: id, page: 0, more: true }; });
        buffer = []; seen = {}; shown = 0; renderedIds = {};
        listEl.innerHTML = '';
      }
      function sortCmp(a, b) {
        if (sort === 'rating') return (b.rating - a.rating) || (new Date(b.date) - new Date(a.date));
        return new Date(b.date) - new Date(a.date);
      }
      /* Imported (KR-archive) reviews carry a backfilled original date — their
         Loox record (createdAt) was created in import batches days-to-years
         later. Native US-purchase reviews are written live, so the two stamps
         agree to within form latency (worst observed: 6h). 24h = safe line. */
      function isImport(rv) {
        return Math.abs(new Date(rv.createdAt || 0) - new Date(rv.date || 0)) > 864e5;
      }
      /* Featured tiers (Ruben 2026-07-16): tier 0 = native purchase reviews
         3★+ (photos → rating → newest — "US 리뷰로 상단", 3-4★ US is fine),
         tier 1 = imported 4-5★ (stable API order), tier 2 = the rest (1-2★
         native + ≤3★ imports) sunk to the very back of the curated view
         (rating desc, then newest). The date / rating sort options still
         show everything unweighted. */
      function featuredTier(rv) {
        if (isImport(rv)) return rv.rating >= 4 ? 1 : 2;
        return rv.rating >= 3 ? 0 : 2;
      }
      function featuredCmp(a, b) {
        var apin = pinnedIds.indexOf(a.id), bpin = pinnedIds.indexOf(b.id);
        if (apin !== bpin) {
          if (apin === -1) return 1;
          if (bpin === -1) return -1;
          return apin - bpin;
        }
        var ta = featuredTier(a), tb = featuredTier(b);
        if (ta !== tb) return ta - tb;
        if (ta === 1) return 0;
        if (ta === 2) return (b.rating - a.rating) || (new Date(b.date) - new Date(a.date));
        var ap = photoOf(a) ? 1 : 0, bp = photoOf(b) ? 1 : 0;
        if (ap !== bp) return bp - ap;
        return (b.rating - a.rating) || (new Date(b.date) - new Date(a.date));
      }
      /* Fetch the next page from every member that still hasMore, merge + de-dupe. */
      function fetchPage() {
        var currentGeneration = generation;
        var pend = members.filter(function (m) { return m.more; });
        if (!pend.length) return Promise.resolve(0);
        return Promise.all(pend.map(function (m) {
          var nextPage = m.page + 1;
          /* featured fetches by date: the native US reviews it must surface are
             recent (page 1 by date) but sit ~page 11 of the API's own featured
             order (photo-first), unreachable through lazy pagination. */
          var apiSort = sort === 'featured' ? 'date' : sort;
          var url = base + '?product_id=' + encodeURIComponent(m.id) + '&sort=' + apiSort + '&limit=30&page=' + nextPage;
          return fetch(url).then(function (r) {
            if (!r.ok) throw new Error('Reviews unavailable');
            return r.json();
          }).then(function (d) {
            if (!Array.isArray(d.reviews) || !d.pagination) throw new Error('Invalid reviews');
            m.page = nextPage;
            m.more = !!d.pagination.hasMore;
            m.failed = false;
            return d.reviews;
          }).catch(function () { m.failed = true; return []; });
        })).then(function (chunks) {
          if (generation !== currentGeneration) return 0;
          listFailed = members.some(function (m) { return m.failed; });
          updateError();
          var added = 0;
          chunks.forEach(function (arr) { arr.forEach(function (rv) { if (rv && rv.id && !seen[rv.id]) { seen[rv.id] = 1; buffer.push(rv); added++; } }); });
          buffer.sort(sort === 'featured' ? featuredCmp : sortCmp);
          return added;
        });
      }
      function updateError() {
        if (errorEl) errorEl.hidden = !(listFailed || summaryFailed);
      }
      function updateBundleSummary() {
        if (!isBundle) return Promise.resolve();
        return Promise.all(ids.map(function (id) {
          return fetch(base + '/bottomline/' + encodeURIComponent(id)).then(function (response) {
            if (!response.ok) throw new Error('Review summary unavailable');
            return response.json();
          });
        })).then(function (summaries) {
          var total = 0, score = 0;
          summaries.forEach(function (summary) {
            var distribution = summary.ratingDistribution;
            var count = 0;
            for (var rating = 1; rating <= 5; rating++) {
              var amount = distribution && distribution[rating];
              if (!Number.isInteger(amount) || amount < 0) throw new Error('Invalid review summary');
              count += amount;
              score += rating * amount;
            }
            if (count !== summary.totalReviews) throw new Error('Incomplete review summary');
            total += count;
          });
          summaryFailed = false;
          updateError();
          var average = total ? (score / total).toFixed(1) : '0';
          root.querySelector('[data-summary-avg]').textContent = average;
          root.querySelector('[data-summary-total]').textContent = total.toLocaleString();
          root.querySelector('[data-summary-stars]').style.setProperty('--pct', Number(average) * 20 + '%');
          root.querySelector('.pdp-reviews__summary').hidden = !total;
          var hero = document.querySelector('[data-bundle-rating="' + root.dataset.productId + '"]');
          if (hero) {
            hero.querySelector('.pdp-buy__rating-value').textContent = average;
            hero.querySelector('.pdp-buy__rating-count').textContent = '(' + total.toLocaleString() + ' ' + root.dataset.countLabel + ')';
            hero.hidden = !total;
          }
        }).catch(function () {
          summaryFailed = true;
          updateError();
          root.querySelector('.pdp-reviews__summary').hidden = true;
          var hero = document.querySelector('[data-bundle-rating="' + root.dataset.productId + '"]');
          if (hero) hero.hidden = true;
        });
      }
      function makeCard(rv) {
        var li = cardTpl.content.firstElementChild.cloneNode(true);
        li.setAttribute('data-review-id', rv.id);
        var q = function (s) { return li.querySelector(s); };
        var nameEl = q('[data-name]');
        nameEl.textContent = (rv.reviewer && rv.reviewer.name) || '';
        if (rv.verified) nameEl.insertAdjacentHTML('beforeend', VERIFIED);
        var st = q('[data-stars]'); st.innerHTML = starsHtml(rv.rating); st.setAttribute('aria-label', Math.round(rv.rating) + ' out of 5 stars');
        if (q('[data-review-product]')) q('[data-review-product]').textContent = reviewProductName(rv);
        q('[data-text]').textContent = rv.body || '';
        q('[data-date]').textContent = fmtDate(rv.date || rv.createdAt);
        var photo = photoOf(rv);
        if (photo) { li.classList.add('pdp-review--photo'); var ph = q('[data-photo]'); ph.hidden = false; q('[data-photo-img]').src = photo.url; }
        q('.pdp-review__open').addEventListener('click', function () { openModal(rv); });
        return li;
      }
      /* Render by id-dedupe, not by index: featured's tiering means a later
         fetch can insert 4-5★ imports BEFORE already-rendered ≤3★ tail items
         (the tier boundary moves as pages arrive), so a bare `shown` cursor
         would re-render or skip. Walk the current order, render the first n
         not-yet-rendered. `shown` stays the rendered COUNT for updateMore. */
      function renderNext(n) {
        var frag = document.createDocumentFragment(), count = 0;
        for (var i = 0; i < buffer.length && count < n; i++) {
          var rv = buffer[i];
          if (renderedIds[rv.id]) continue;
          renderedIds[rv.id] = 1;
          frag.appendChild(makeCard(rv));
          count++;
        }
        shown += count;
        listEl.appendChild(frag);
        updateMore();
      }
      function updateMore() {
        if (!moreBtn) return;
        moreBtn.hidden = !(shown < buffer.length || members.some(function (m) { return m.more; }));
      }
      function loadMore() {
        if (shown + STEP <= buffer.length) { renderNext(STEP); return; }
        if (moreBtn) moreBtn.disabled = true;
        var currentGeneration = generation;
        fetchPage().then(function () {
          if (generation !== currentGeneration) return;
          if (moreBtn) moreBtn.disabled = false;
          renderNext(STEP);
        });
      }
      function openModal(rv) {
        if (!modal) return;
        var q = function (s) { return modal.querySelector(s); };
        var photo = photoOf(rv);
        modal.classList.toggle('pdp-review-detail--photo', !!photo);
        var media = q('[data-modal-media]');
        if (photo) { media.hidden = false; q('[data-modal-img]').src = photo.url; } else { media.hidden = true; q('[data-modal-img]').removeAttribute('src'); }
        q('[data-modal-name]').textContent = (rv.reviewer && rv.reviewer.name) || '';
        q('[data-modal-verified]').hidden = !rv.verified;
        var ms = q('[data-modal-stars]'); ms.innerHTML = starsHtml(rv.rating); ms.setAttribute('aria-label', Math.round(rv.rating) + ' out of 5 stars');
        q('[data-modal-date]').textContent = fmtDate(rv.date || rv.createdAt);
        if (q('[data-modal-product]')) q('[data-modal-product]').textContent = reviewProductName(rv);
        q('[data-modal-text]').textContent = rv.body || '';
        var reply = q('[data-modal-reply]');
        if (rv.reply && rv.reply.body) { reply.hidden = false; q('[data-modal-reply-label]').textContent = replyLabel; q('[data-modal-reply-text]').textContent = rv.reply.body; }
        else { reply.hidden = true; }
        if (typeof modal.showModal === 'function') modal.showModal();
      }
      function init() {
        reset();
        var currentGeneration = generation;
        if (moreBtn) { moreBtn.disabled = false; moreBtn.hidden = true; }
        if (emptyEl) emptyEl.hidden = true;
        updateError();
        listEl.setAttribute('aria-busy', 'true');
        /* Fetch pins directly so new reviews cannot push them outside page 1.
           Wait for all pins before rendering, including when a retry is needed. */
        var pins = fetchPinnedReviews().then(function (reviews) {
          return { reviews: reviews, failed: false };
        }).catch(function () { return { reviews: [], failed: true }; });
        Promise.all([fetchPage(), pins]).then(function (results) {
          if (generation !== currentGeneration) return;
          var pinned = results[1];
          listEl.setAttribute('aria-busy', 'false');
          listFailed = listFailed || pinned.failed;
          updateError();
          if (pinned.failed) return;
          pinned.reviews.forEach(function (review) {
            if (!seen[review.id]) { seen[review.id] = 1; buffer.push(review); }
          });
          buffer.sort(sort === 'featured' ? featuredCmp : sortCmp);
          if (!buffer.length) { if (emptyEl) emptyEl.hidden = listFailed; if (moreBtn) moreBtn.hidden = true; return; }
          if (emptyEl) emptyEl.hidden = true;
          renderNext(Math.max(visible, pinned.reviews.length));
        });
      }

      /* Standalone badges retain Loox metafields. Bundle summaries use only
         the product-specific bottomline endpoints, including zero-review IDs. */

      if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
      if (sortSel) sortSel.addEventListener('change', function () {
        var v = sortSel.value;
        sort = (v === 'rating' || v === 'featured') ? v : 'date';
        if (sortLabel) sortLabel.textContent = 'Sort by (' + sortSel.options[sortSel.selectedIndex].text + ')';
        init();
      });
      if (moreBtn) moreBtn.addEventListener('click', loadMore);
      if (retryBtn) retryBtn.addEventListener('click', function () { updateBundleSummary(); init(); });

      updateBundleSummary();
      init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp]').forEach(function (root) {
      /* --- Size / variant selection (synced across buy block + sticky bar) --- */
      var sizes = Array.prototype.slice.call(root.querySelectorAll('.pdp-size'));
      var atc = root.querySelector('[data-pdp-atc]');
      var atcPrice = atc && atc.querySelector('[data-pdp-atc-price]');
      var stickyAtc = root.querySelector('[data-sticky-atc]');
      var stickyPrice = root.querySelector('[data-sticky-atc-price]');
      var stickySelect = root.querySelector('[data-sticky-select]');
      var stickyLabel = root.querySelector('[data-sticky-size-label]');
      var selected = root.querySelector('.pdp-size.is-selected') || sizes[0];
      var bisTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-bis-trigger]'));
      var installmentForm = root.querySelector('[data-pdp-installments-form]');
      var installmentTerms = installmentForm && installmentForm.querySelector('shopify-payment-terms');
      var installmentCopy = installmentForm && installmentForm.querySelector('[data-pdp-installments-copy]');
      var installmentNative = installmentForm && installmentForm.querySelector('[data-pdp-installments-native]');
      var installmentSubtotal = installmentForm && installmentForm.querySelector('[data-cart-subtotal]');
      var installmentMeta;
      try { installmentMeta = installmentTerms && JSON.parse(installmentTerms.getAttribute('shopify-meta')); }
      catch (error) {}
      var installmentMoney = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

      function publishInstallmentOffer(offer) {
        root.hinokInstallmentOffer = offer;
        root.dispatchEvent(new CustomEvent('pdp:installments-change', { bubbles: true }));
      }

      function updateInstallments() {
        if (!installmentTerms || !installmentCopy || !installmentNative) return;
        var total = atc && Number(atc.getAttribute('data-pdp-purchase-total'));
        installmentForm.hidden = true;
        installmentCopy.hidden = true;
        installmentNative.hidden = false;
        if (!Number.isInteger(total) || total <= 0 || atc.hidden || (atcPrice && atcPrice.hidden) || !selectedAvailable()) {
          publishInstallmentOffer({ eligible: false });
          return;
        }
        if (!installmentMeta || !Array.isArray(installmentMeta.financing_plans)) {
          publishInstallmentOffer({ eligible: false });
          return;
        }
        var plan = installmentMeta.financing_plans.find(function (item) {
          return total >= Math.round(item.min_price_amount * 100) && total <= Math.round(item.max_price_amount * 100);
        });
        var split = plan && Array.isArray(plan.terms) && plan.terms.reduce(function (chosen, term) {
          if (term.loan_type !== 'split_pay' || term.apr !== 0 || !Number.isInteger(term.installments_count) || term.installments_count < 1) return chosen;
          return !chosen || term.installments_count > chosen.installments_count ? term : chosen;
        }, null);
        if (!split) {
          publishInstallmentOffer({ eligible: false });
          return;
        }
        var count = split.installments_count;
        var amount = Math.floor(total / count);
        var formattedTotal = installmentMoney.format(total / 100);
        var formattedAmount = installmentMoney.format(amount / 100);
        var nativeData = Object.assign({}, installmentMeta, {
          type: 'cart',
          full_price: formattedTotal, full_price_amount: total / 100,
          price_per_term: formattedAmount, price_per_term_amount: amount / 100,
          number_of_payment_terms: count, eligible: true
        });
        delete nativeData.variants;
        var nativeMeta = JSON.stringify(nativeData);
        if (installmentTerms.getAttribute('shopify-meta') !== nativeMeta) installmentTerms.setAttribute('shopify-meta', nativeMeta);
        if (installmentSubtotal.textContent !== formattedTotal) installmentSubtotal.textContent = formattedTotal;
        installmentCopy.querySelector('[data-pdp-installment-count]').textContent = count;
        installmentCopy.querySelector('[data-pdp-installment-amount]').textContent = formattedAmount;
        installmentCopy.hidden = false;
        installmentNative.hidden = true;
        publishInstallmentOffer({ eligible: true, total: total, count: count, variant: atc.getAttribute('data-variant-id') });
      }
      updateInstallments();
      root.addEventListener('pdp:purchase-total-change', updateInstallments);
      if (installmentCopy) installmentCopy.addEventListener('click', function () {
        var nativeButton = installmentTerms && installmentTerms.shadowRoot && installmentTerms.shadowRoot.querySelector('button[aria-haspopup="dialog"]');
        if (nativeButton) nativeButton.click();
        else {
          installmentCopy.hidden = true;
          installmentNative.hidden = false;
        }
      });

      function select(btn) {
        if (!btn) return;
        selected = btn;
        var id = btn.getAttribute('data-variant-id');
        var pm = btn.getAttribute('data-price');
        var lbEl = btn.querySelector('.pdp-size__label');
        var lb = lbEl ? lbEl.textContent : '';
        sizes.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1; /* roving tabindex (radiogroup pattern) */
        });
        if (atc) atc.setAttribute('data-variant-id', id);
        if (atcPrice && pm) atcPrice.textContent = pm;
        if (atc) atc.setAttribute('data-pdp-purchase-total', btn.getAttribute('data-variant-price'));
        var installmentVariant = root.querySelector('[data-pdp-installments-variant]');
        if (installmentVariant && installmentVariant.value !== id) {
          installmentVariant.value = id;
          installmentVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateInstallments();
        /* mirror the selection into the sticky bar */
        if (stickyAtc) stickyAtc.setAttribute('data-variant-id', id);
        if (stickyPrice && pm) stickyPrice.textContent = pm;
        if (stickyLabel && lb) stickyLabel.textContent = lb;
        if (stickySelect && stickySelect.value !== id) stickySelect.value = id;
        /* Re-point the notify buttons too: assets/bis.js reads the variant off
           the trigger at click time, so a stale id here would subscribe the
           shopper to the size they switched AWAY from. */
        bisTriggers.forEach(function (b) { b.setAttribute('data-variant-id', id); });
        if (typeof syncBuyState === 'function') syncBuyState();
        root.dispatchEvent(new CustomEvent('pdp:variant-change', { bubbles: true }));
      }
      /* --- Back in stock (Klaviyo BIS): swap ATC <-> notify per availability --- */
      var notify = root.querySelector('[data-pdp-notify]');
      var IS_LIVE_DOMAIN = window.location.hostname === 'hinok.us';
      var BIS_FORCE = window.location.search.indexOf('bis-preview') > -1;
      function selectedAvailable() {
        if (BIS_FORCE) return false;
        if (atc && atc.hasAttribute('data-b2b-portal-cta')) return true;
        var el = selected || atc;
        return !el || el.getAttribute('data-available') !== 'false';
      }
      var stickySoldout = root.querySelector('[data-sticky-soldout]');
      var soldoutLabels = root.querySelectorAll('.pdp-soldout, .pdp-sticky__sold-label');
      /* assigned by the sticky-bar block below (null until then): the swap
         changes WHICH control the bar's visibility rule observes */
      var onAnchorSwap = null;
      function syncBuyState() {
        if (!notify || !atc) return;
        if (!IS_LIVE_DOMAIN && !BIS_FORCE) return; /* preview market artifact: keep ATC */
        var avail = selectedAvailable();
        soldoutLabels.forEach(function (label) { label.textContent = avail ? '' : label.dataset.soldOut; });
        atc.hidden = !avail;
        notify.hidden = avail;
        if (stickyAtc) stickyAtc.hidden = !avail;
        if (stickySoldout) stickySoldout.hidden = avail;
        var stickyEl = root.querySelector('[data-pdp-sticky]');
        if (stickyEl) stickyEl.classList.toggle('pdp-sticky--soldout', !avail);
        if (onAnchorSwap) onAnchorSwap();
        updateInstallments();
      }
      /* BIS dialog: opening, closing and the Klaviyo submit now live in
         assets/bis.js, shared with the grids' sold-out cards (2026-07-30).
         The buttons carry [data-bis-trigger] + data-variant-id (kept current
         by select() above); this section only owns the ATC <-> notify swap. */

      /* --- Entry announcement dialog: same grammar as BIS, no form. Shows
         once per browser session (key shared across products so the spray
         family doesn't re-nag while browsing between its PDPs). --- */
      var annModal = root.querySelector('[data-announce-modal]');
      if (annModal) {
        var ANN_KEY = 'hinok-pdp-announce-seen';
        var closeAnn = function () {
          annModal.hidden = true;
          document.documentElement.style.overflow = '';
        };
        annModal.querySelectorAll('[data-announce-close]').forEach(function (b) {
          b.addEventListener('click', closeAnn);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !annModal.hidden) closeAnn();
        });
        var seen = false;
        try { seen = sessionStorage.getItem(ANN_KEY) === '1'; } catch (err) {}
        if (!seen) {
          annModal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          try { sessionStorage.setItem(ANN_KEY, '1'); } catch (err) {}
        }
      }

      root.addEventListener('pdp:availability-change', syncBuyState);
      sizes.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
      syncBuyState();

      /* --- Tab media loops: lazy start on approach, pause off-screen/hidden tab --- */
      (function () {
        var vids = root.querySelectorAll('.pdp-tabs__media video');
        if (!vids.length) return;
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return; /* first frame stays as a still */
        var start = function (v) { if (v.paused) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
        if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) start(e.target);
            else if (!e.target.paused) e.target.pause();
          });
        }, { rootMargin: '200px 0px' });
        vids.forEach(function (v) { io.observe(v); });
      })();
      /* Radiogroup keyboard pattern: arrows move selection between sizes */
      var sizeGroup = root.querySelector('[data-pdp-sizes]');
      if (sizeGroup && sizes.length > 1) {
        sizes.forEach(function (b) { b.tabIndex = (b === selected) ? 0 : -1; });
        sizeGroup.addEventListener('keydown', function (e) {
          var dir = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
          if (!dir) return;
          e.preventDefault();
          var i = sizes.indexOf(selected);
          var next = sizes[(i + dir + sizes.length) % sizes.length];
          select(next);
          next.focus();
        });
      }
      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          var id = stickySelect.value;
          select(sizes.filter(function (b) { return b.getAttribute('data-variant-id') === id; })[0]);
        });
      }

      /* --- Add to cart → cart drawer (respects the selected variant) --- */
      var pendingId = null;
      var pendingRequestId = null;
      function collectGiftCardProperties() {
        var recipient = root.querySelector('[data-gift-card-recipient]');
        if (!recipient) return {};
        var toggle = recipient.querySelector('[data-gift-card-recipient-toggle]');
        if (!toggle || !toggle.checked) return {};
        var properties = {};
        var fields = recipient.querySelectorAll('[name^="properties["]:not([disabled])');
        for (var i = 0; i < fields.length; i += 1) {
          var field = fields[i];
          if (!field.checkValidity()) {
            field.reportValidity();
            return null;
          }
          var propertyName = field.name.slice(11, -1);
          if (propertyName && field.value !== '') properties[propertyName] = field.value;
        }
        return properties;
      }
      function addToCart(trigger) {
        if (root.hinokJourney) { root.hinokJourney.add(); return; }
        if (root.hinokSubscription && root.hinokSubscription.active()) { root.hinokSubscription.add(); return; }
        var id = (selected && selected.getAttribute('data-variant-id')) || (trigger && trigger.getAttribute('data-variant-id'));
        if (!id) return;
        var properties = collectGiftCardProperties();
        if (properties === null) return;
        pendingId = String(id);
        pendingRequestId = 'pdp-' + crypto.randomUUID();
        if (atc) atc.disabled = true;
        if (stickyAtc) stickyAtc.disabled = true;
        document.dispatchEvent(new CustomEvent('cart:add', {
          detail: { id: id, quantity: 1, handle: root.getAttribute('data-product-handle'), properties: properties, requestId: pendingRequestId, source: 'pdp' }
        }));
        /* safety net: re-enable even if no cart drawer answered (e.g. removed from template) */
        setTimeout(function () { if (atc) atc.disabled = false; if (stickyAtc) stickyAtc.disabled = false; }, 8000);
      }
      if (atc && !atc.hasAttribute('data-b2b-portal-cta')) atc.addEventListener('click', function () { addToCart(atc); });
      if (stickyAtc && !stickyAtc.hasAttribute('data-b2b-portal-cta')) stickyAtc.addEventListener('click', function () { addToCart(stickyAtc); });
      document.addEventListener('cart:add:done', function (e) {
        var d = (e && e.detail) || {};
        if (pendingId && d.requestId === pendingRequestId) {
          if (atc) atc.disabled = false;
          if (stickyAtc) stickyAtc.disabled = false;
          pendingId = null;
          pendingRequestId = null;
        }
      });

      /* --- Sticky ATC bar visibility (mobile rule reworked 2026-07-30, Ruben) ---
         MOBILE (<990): the bar is up whenever the main ATC control is NOT fully
         on screen, applied from the first frame the script runs (no scroll
         threshold any more). "Not fully on screen" rather than the container's
         intersection ratio, because measured at load the main control is only
         clipped at the fold while `.pdp-buy` is already 27-88% visible
         (390x844: 8px of the 30px button; 375x667: buy box 0.31): keying off the
         container would drop the bar exactly when the shopper has no tappable
         button. The bar exists to guarantee a tappable CTA, so it stands down
         only once the real control is fully tappable.
         DESKTOP (>=990): unchanged — the bar slides up only after the control
         has scrolled ABOVE the viewport top.
         An IntersectionObserver drives the mobile rule (threshold ladder, exact
         rect math in the callback); the rAF scroll read stays as the net for
         instant anchor jumps, the desktop rule, and no-IO browsers.
         Flip guards: a 24px hysteresis band (hide needs full visibility, show
         needs the control clearly away) plus a 180ms debounce, so a pixel wobble
         at the boundary cannot strobe the bar.
         Overlays (cart drawer, BIS dialog, entry announcement) force it down so
         it can never sit over an open panel. --- */
      var sticky = root.querySelector('[data-pdp-sticky]');
      if (sticky && atc) {
        var DESK_MQ = window.matchMedia('(min-width: 990px)');
        /* Keep the band NARROW: it only has to absorb sub-pixel jitter, the
           180ms debounce does the real anti-strobe work. A wide band leaves the
           bar's state history-dependent at scroll 0, where a shopper who came
           back up would sit with an 8px sliver of the real button and no bar. */
        var HYST = 6;                         /* px band between hide and show */
        var FLIP_MS = 180;                    /* debounce on rule-driven flips */
        var stMode = null;                    /* 'mobile' | 'desktop' */
        var stVisible = null, stRule = false, stOverlay = false;
        var stFlipT = null, stIO = null, stTicking = false;
        var stShown = false, stBooted = false;
        var stNow = function () {
          return (window.performance && performance.now) ? Math.round(performance.now()) : null;
        };
        var stVh = function () { return window.innerHeight || document.documentElement.clientHeight; };
        /* anchor on whichever CTA is actually in the flow — a display:none ATC
           (sold-out swap) reads rect 0/0 and would pin the bar on for ever */
        var stAnchor = function () {
          return (atc.hidden && notify && !notify.hidden) ? notify : atc;
        };
        var stApply = function (next) {
          if (next === stVisible) return;
          stVisible = next;
          sticky.classList.toggle('is-visible', next);
          sticky.setAttribute('aria-hidden', next ? 'false' : 'true');
          sticky.toggleAttribute('inert', !next);   /* off-screen controls must not be tabbable */
          if (next && !stShown) {
            stShown = true;
            /* exposure signal for posthog-events.liquid (sticky_visible); the
               analytics snippet owns the capture so event names stay in one file */
            document.dispatchEvent(new CustomEvent('pdp:sticky-visible', {
              detail: { at_load: !stBooted, mode: stMode, t_ms: stNow() }
            }));
          }
        };
        var stSettle = function (immediate) {
          var next = stRule && !stOverlay;
          if (stFlipT) { clearTimeout(stFlipT); stFlipT = null; }
          if (next === stVisible) return;
          if (immediate) { stApply(next); return; }
          stFlipT = setTimeout(function () {
            stFlipT = null;
            stApply(stRule && !stOverlay);
          }, FLIP_MS);
        };
        /* true = bar up, false = bar down, null = inside the band, keep as is.
           Up is the complement of "fully tappable", NOT "fully off screen": at
           scroll 0 a phone shows an 8px sliver of the button, and treating that
           as visible would leave the shopper with nothing to tap. */
        var stDecide = function (r, vh) {
          if (r.top >= 0 && r.bottom <= vh) return false;
          if (r.top < -HYST || r.bottom > vh + HYST) return true;
          return null;
        };
        var stRead = function () {
          var el = stAnchor();
          if (!el) return;
          var r = el.getBoundingClientRect();
          if (stMode === 'desktop') { stRule = r.bottom < 0; return; }
          var d = stDecide(r, stVh());
          if (d !== null) stRule = d;
        };
        /* seed ignores the hysteresis band: at t=0 (and on a mode switch) there
           is no previous state to hold on to */
        var stSeed = function () {
          var el = stAnchor();
          if (!el) return;
          var r = el.getBoundingClientRect();
          stRule = (stMode === 'desktop') ? (r.bottom < 0) : !(r.top >= 0 && r.bottom <= stVh());
        };
        var stStartIO = function () {
          if (stIO) { stIO.disconnect(); stIO = null; }
          if (stMode !== 'mobile' || !('IntersectionObserver' in window)) return;
          var el = stAnchor();
          if (!el) return;
          stIO = new IntersectionObserver(function (entries) {
            var e = entries[entries.length - 1];
            var vh = (e.rootBounds && e.rootBounds.height) || stVh();
            var d = stDecide(e.boundingClientRect, vh);
            if (d !== null) { stRule = d; stSettle(false); }
          }, { threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 0.9, 0.99, 1] });
          stIO.observe(el);
        };
        var stSetMode = function () {
          var next = DESK_MQ.matches ? 'desktop' : 'mobile';
          if (next === stMode) return;
          stMode = next;
          sticky.classList.add('pdp-sticky--noanim');   /* a mode switch must not slide */
          stStartIO();
          stSeed();
          stSettle(true);
          window.requestAnimationFrame(function () { sticky.classList.remove('pdp-sticky--noanim'); });
        };
        var stOnScroll = function () {
          if (stTicking) return;
          stTicking = true;
          window.requestAnimationFrame(function () {
            stTicking = false;
            stRead();
            stSettle(stMode === 'desktop');   /* desktop keeps its instant response */
          });
        };
        /* Overlay gate: the cart drawer flags itself with .is-open, and every
           in-page panel (drawer, BIS, announcement) locks <html> overflow. */
        var stDrawer = document.querySelector('.cart-drawer');
        var stReadOverlay = function () {
          var next = document.documentElement.style.overflow === 'hidden' ||
                     !!(stDrawer && stDrawer.classList.contains('is-open'));
          if (next === stOverlay) return;
          stOverlay = next;
          sticky.classList.toggle('pdp-sticky--noanim', next);  /* drop it instantly under a panel */
          stSettle(true);
          if (!next) window.requestAnimationFrame(function () { sticky.classList.remove('pdp-sticky--noanim'); });
        };
        /* re-target + re-seed when the sold-out swap changes which control is in
           the flow (called from syncBuyState) */
        onAnchorSwap = function () {
          stStartIO();
          stSeed();
          stSettle(true);
        };

        sticky.hidden = false; /* present now; CSS transform holds it off-screen until is-visible */
        sticky.setAttribute('inert', '');
        sticky.classList.add('pdp-sticky--noanim');
        stSetMode();
        stReadOverlay();
        stBooted = true;
        window.requestAnimationFrame(function () { sticky.classList.remove('pdp-sticky--noanim'); });
        window.addEventListener('scroll', stOnScroll, { passive: true });
        window.addEventListener('resize', function () { stSetMode(); stOnScroll(); }, { passive: true });
        window.addEventListener('orientationchange', function () { stSetMode(); stOnScroll(); });
        if (DESK_MQ.addEventListener) DESK_MQ.addEventListener('change', stSetMode);
        else if (DESK_MQ.addListener) DESK_MQ.addListener(stSetMode);
        if (window.MutationObserver) {
          var stMo = new MutationObserver(stReadOverlay);
          stMo.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
          if (stDrawer) stMo.observe(stDrawer, { attributes: true, attributeFilter: ['class'] });
        }
      }

      /* --- Gallery ↔ thumbnail sync --- */
      var main = root.querySelector('[data-gallery-main]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
      var galleryVideos = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-video]'));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var galleryVisible = true;
      var syncGalleryVideos = function (index) {
        galleryVideos.forEach(function (video) {
          var slide = video.closest('.pdp-gallery__slide');
          var slideIndex = Array.prototype.indexOf.call(main.children, slide);
          var shouldPlay = slideIndex === index && galleryVisible && !reduceMotion.matches && document.visibilityState === 'visible';
          if (shouldPlay) {
            var playback = video.play();
            if (playback && playback.catch) playback.catch(function () {});
          } else {
            video.pause();
          }
        });
      };
      if (main && galleryVideos.length) {
        var currentGalleryIndex = function () {
          return Math.round(main.scrollLeft / (main.clientWidth || 1));
        };
        var visibilityObserver = new IntersectionObserver(function (entries) {
          galleryVisible = entries[0] ? entries[0].isIntersecting : true;
          syncGalleryVideos(currentGalleryIndex());
        }, { threshold: 0.15 });
        visibilityObserver.observe(main);
        document.addEventListener('visibilitychange', function () {
          syncGalleryVideos(currentGalleryIndex());
        });
        var onMotionPreferenceChange = function () {
          syncGalleryVideos(currentGalleryIndex());
        };
        if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionPreferenceChange);
        else reduceMotion.addListener(onMotionPreferenceChange);
        syncGalleryVideos(0);
      }
      if (main && thumbs.length) {
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var i = +t.getAttribute('data-gallery-thumb');
            var slide = main.children[i];
            /* mainDrag's settle animator (assigned below) cancels any in-flight
               settle, so a tap right after a swipe lands on the tapped image */
            if (slide) mainDrag.settleTo(slide.offsetLeft - main.offsetLeft);
          });
        });
        var setActive = function (i) {
          thumbs.forEach(function (t) {
            var on = +t.getAttribute('data-gallery-thumb') === i;
            t.classList.toggle('is-active', on);
            if (on) t.scrollIntoView({ inline: 'nearest', block: 'nearest' });
          });
          syncGalleryVideos(i);
        };
        var settle, lastIdx = 0;
        main.addEventListener('scroll', function () {
          var idx = Math.round(main.scrollLeft / main.clientWidth);
          if (idx !== lastIdx) {
            lastIdx = idx;
            /* Header switches to the frosted bar from the 2nd gallery image on
               (header.liquid listens; varying photo bgs would swallow the logo). */
            document.dispatchEvent(new CustomEvent('pdp:gallery-index', { detail: { index: idx } }));
          }
          clearTimeout(settle);
          settle = setTimeout(function () { setActive(idx); }, 90);
        }, { passive: true });
      }

      /* Drag-to-scroll for the image carousel + the thumbnail row.
         Mouse: a move past a few px marks a drag and suppresses the click after
         it, so dragging over a thumbnail doesn't also switch the image.
         TOUCH is fully native (device QA, Ruben 2026-07-10): the earlier JS
         axis lock rode on touch-action: pan-y, so the browser could claim any
         gesture carrying a few px of vertical drift (pointercancel) — real
         device swipes died unless perfectly horizontal. The scroller already
         has scroll-snap-type: x mandatory + overscroll-behavior-x: contain,
         so native pan delivers the Instagram feel (axis disambiguation,
         momentum, snap) without the gesture-ownership race. The one JS touch
         job left: a touchdown cancels an in-flight settle (thumb tap /
         click-nav) so the swipe starts from wherever the carousel is. */
      var dragScroll = function (el, snapToSlides) {
        if (!el) return;
        var down = false, moved = false, axis = 0, caught = false, sx = 0, sy = 0, sl = 0, pid = null, lastX = 0, lastT = 0, vx = 0;
        var anim = null;
        var setSnap = function (on) { el.style.scrollSnapType = on ? '' : 'none'; };
        /* Cancel a running settle. Snap state is left to the caller (a drag
           keeps it off; a fresh settle re-disables it). True if one was live. */
        var stopSettle = function () { if (!anim) return false; cancelAnimationFrame(anim); anim = null; return true; };
        /* rAF ease-out settle we own end-to-end: mandatory snap stays off until
           the animation lands (no re-enable race with the browser's smooth
           scroll), and a new pointerdown can catch the carousel mid-flight. */
        var settleTo = function (target) {
          stopSettle();
          setSnap(false);
          var from = el.scrollLeft, dist = target - from;
          if (!dist) { setSnap(true); return; }
          var dur = Math.min(400, Math.max(220, Math.abs(dist) * 0.6));
          var t0 = null;
          var step = function (ts) {
            if (t0 === null) t0 = ts;
            var p = Math.min(1, (ts - t0) / dur);
            el.scrollLeft = from + dist * (1 - Math.pow(1 - p, 3)); /* easeOutCubic */
            if (p < 1) anim = requestAnimationFrame(step);
            else { anim = null; setSnap(true); }
          };
          anim = requestAnimationFrame(step);
        };
        el.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') {
            /* touch/pen: native scroll-snap owns the gesture — just free a
               settling carousel so the swipe starts where the eye is */
            if (stopSettle()) setSnap(true);
            return;
          }
          if (e.button !== 0) return;
          if (down) return; /* a second concurrent pointer keeps the first gesture's frame */
          caught = stopSettle(); /* grab a settling carousel mid-flight, right where it is */
          down = true; moved = false; axis = 0; sx = e.clientX; sy = e.clientY; sl = el.scrollLeft; pid = e.pointerId;
          lastX = e.clientX; lastT = e.timeStamp; vx = 0;
        });
        el.addEventListener('pointermove', function (e) {
          if (!down || e.pointerId !== pid || axis < 0) return;
          var dx = e.clientX - sx;
          if (!axis) {
            if (Math.abs(dx) < 5) return; /* still a click, not a drag → never capture, so thumbnail clicks keep working */
            axis = 1; moved = true; el.classList.add('is-dragging'); setSnap(false);
            try { el.setPointerCapture(pid); } catch (err) {}
          }
          e.preventDefault();
          el.scrollLeft = sl - dx;
          var dt = e.timeStamp - lastT;              /* track pointer velocity for flick detection */
          if (dt > 0) vx = (e.clientX - lastX) / dt; /* px per ms; negative = swiping toward the next image */
          lastX = e.clientX; lastT = e.timeStamp;
        });
        var end = function (e) {
          if (!down || e.pointerId !== pid) return;
          down = false; axis = 0; el.classList.remove('is-dragging');
          if (moved && snapToSlides) {
            var w = el.clientWidth || 1;
            var maxIdx = Math.max(0, el.children.length - 1);
            var startIdx = Math.round(sl / w);
            var dragged = el.scrollLeft - sl;
            var target = startIdx;
            /* A light flick OR a short (>15%) drag advances one image — no need to
               drag past the halfway point (Koppen-style momentum feel). A cancelled
               pointer (a system gesture stole it) just settles to the nearest. */
            if (e && e.type === 'pointercancel') target = Math.round(el.scrollLeft / w);
            else if (Math.abs(vx) > 0.3) target = startIdx + (vx < 0 ? 1 : -1);
            else if (Math.abs(dragged) > w * 0.15) target = startIdx + (dragged > 0 ? 1 : -1);
            target = Math.max(0, Math.min(maxIdx, target));
            settleTo(target * w);
          } else if (caught && snapToSlides) {
            /* tapped to freeze a settling carousel: ease to the nearest slide */
            var cw = el.clientWidth || 1;
            settleTo(Math.round(el.scrollLeft / cw) * cw);
          } else {
            setSnap(true);
          }
        };
        el.addEventListener('pointerup', end);
        el.addEventListener('pointercancel', end);
        /* suppress the click that follows a real drag (so a drag over a thumb doesn't also switch) */
        el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
        return { settleTo: settleTo };
      };
      var mainDrag = dragScroll(main, true);
      dragScroll(root.querySelector('[data-gallery-thumbs]'), false);

      /* Koppen click-nav (desktop pointer): the stage's left/right halves page
         the carousel, and the cursor becomes a directional arrow so the model
         reads as click-to-browse (drag still works; a real drag suppresses the
         click via the capture handler above). */
      if (main && window.matchMedia('(pointer: fine)').matches) {
        var ARROW_L = 'url("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2234%22 height=%2234%22 viewBox=%220 0 34 34%22><path d=%22M21 7 11 17l10 10%22 fill=%22none%22 stroke=%22%23003a40%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/></svg>") 17 17, w-resize';
        var ARROW_R = 'url("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2234%22 height=%2234%22 viewBox=%220 0 34 34%22><path d=%22m13 7 10 10-10 10%22 fill=%22none%22 stroke=%22%23003a40%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/></svg>") 17 17, e-resize';
        main.addEventListener('mousemove', function (e) {
          if (main.classList.contains('is-dragging')) return;
          var r = main.getBoundingClientRect();
          main.style.cursor = e.clientX < r.left + r.width / 2 ? ARROW_L : ARROW_R;
        });
        main.addEventListener('mouseleave', function () { main.style.cursor = ''; });
        main.addEventListener('click', function (e) {
          if (e.target.closest('[data-gallery-thumbs]')) return;
          if (e.target.closest('[data-gallery-video]')) return;
          var r = main.getBoundingClientRect();
          var w = main.clientWidth || 1;
          var idx = Math.round(main.scrollLeft / w);
          var maxIdx = Math.max(0, main.children.length - 1);
          var target = e.clientX < r.left + r.width / 2 ? idx - 1 : idx + 1;
          target = Math.max(0, Math.min(maxIdx, target));
          if (target !== idx) mainDrag.settleTo(target * w);
        });
      }
    });
  })();

  /* Tabs (merged into this section) — swap body + media + sliding underline. */
  (function () {
    document.querySelectorAll('[data-pdp-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      var nav = root.querySelector('.pdp-tabs__nav');
      var ink = root.querySelector('[data-tab-ink]');
      function moveInk() {
        var active = root.querySelector('.pdp-tabs__tab.is-active');
        if (!ink || !active || !nav) return;
        ink.style.insetInlineStart = active.offsetLeft + 'px';
        ink.style.width = active.offsetWidth + 'px';
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var on = t.getAttribute('data-tab') === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === i); });
          moveInk();
        });
      });
      moveInk();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveInk);
      window.addEventListener('resize', moveInk);
      root.querySelectorAll('.pdp-tabs__more[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var target = document.getElementById(link.getAttribute('href').slice(1));
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      });
    });
  })();

  /* Tall-rail bottom alignment (Sohyun 2026-09-29): when the buy rail outgrows
     the 100svh gallery floor, flag the PDP so CSS drops the rail's bottom
     margin and the rail + gallery close on one bottom line. Tall = the rail (plus its 64px
     top margin) would drive the row even with no bottom margin, so dropping it
     lands the bottoms flush; anything shorter stays centered. offsetHeight
     excludes margins, and
     the toggle never feeds back on itself. */
  (function () {
    var pdp = document.querySelector('.pdp');
    var rail = document.querySelector('.pdp-rail');
    if (!pdp || !rail) return;
    var mq = window.matchMedia('(min-width: 990px)');
    function sync() {
      if (!mq.matches) { pdp.classList.remove('pdp--tall-rail'); return; }
      pdp.classList.toggle('pdp--tall-rail', rail.offsetHeight + 64 >= window.innerHeight - 24);
    }
    sync();
    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('load', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SETS = 3; /* clone sets on each side — buffer absorbs fast flings */
    document.querySelectorAll('.reviews__slider').forEach(function (track) {
      var cards = Array.prototype.slice.call(track.children);
      var n = cards.length;
      if (n < 2) return; /* nothing to loop */

      var clone = function (node) {
        var c = node.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
        Array.prototype.slice.call(c.attributes).forEach(function (a) {
          if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name);
        });
        return c;
      };
      var prepend = [], append = [];
      for (var k = 0; k < SETS; k++) {
        cards.forEach(function (c) { prepend.push(clone(c)); append.push(clone(c)); });
      }
      prepend.forEach(function (c) { track.insertBefore(c, cards[0]); });
      append.forEach(function (c) { track.appendChild(c); });

      var realStart = SETS * n; /* index of the first real card */
      var step = function () {
        return track.children[1].offsetLeft - track.children[0].offsetLeft;
      };
      var center = function () { track.scrollLeft = realStart * step(); };
      /* Once a fling settles, snap the position back into the real set (instant,
         invisible — the clones are identical) so there is always buffer to scroll
         into. Native momentum is untouched, so fast swipes stay smooth. */
      var recenter = function () {
        var s = step();
        if (!s) return;
        var i = Math.round(track.scrollLeft / s);
        var realIdx = realStart + (((i % n) + n) % n);
        if (i !== realIdx) track.scrollLeft = realIdx * s;
      };

      requestAnimationFrame(center);

      var settle;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(recenter, 150);
      }, { passive: true });
      window.addEventListener('resize', center);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-props"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SETS = 3; /* clone sets on each side — buffer absorbs fast flings */
    document.querySelectorAll('.value-props__cards').forEach(function (track) {
      var cards = Array.prototype.slice.call(track.children);
      var n = cards.length;
      if (n < 2) return;

      var clone = function (node) {
        var c = node.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
        Array.prototype.slice.call(c.attributes).forEach(function (a) {
          if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name);
        });
        return c;
      };
      var prepend = [], append = [];
      for (var k = 0; k < SETS; k++) {
        cards.forEach(function (c) { prepend.push(clone(c)); append.push(clone(c)); });
      }
      prepend.forEach(function (c) { track.insertBefore(c, cards[0]); });
      append.forEach(function (c) { track.appendChild(c); });

      var realStart = SETS * n;
      var step = function () {
        return track.children[1].offsetLeft - track.children[0].offsetLeft;
      };
      var center = function () { track.scrollLeft = realStart * step(); };
      var recenter = function () {
        var s = step();
        if (!s) return;
        var i = Math.round(track.scrollLeft / s);
        var realIdx = realStart + (((i % n) + n) % n);
        if (i !== realIdx) track.scrollLeft = realIdx * s;
      };

      requestAnimationFrame(center);

      var settle;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(recenter, 150);
      }, { passive: true });
      window.addEventListener('resize', center);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-clients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ws-clients]').forEach(function (root) {
      var clients = Array.prototype.slice.call(root.querySelectorAll('[data-client]'));
      var navs = Array.prototype.slice.call(root.querySelectorAll('[data-client-nav]'));
      navs.forEach(function (nav) {
        nav.addEventListener('click', function () {
          var i = nav.getAttribute('data-client-nav');
          clients.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-client') === i); });
          navs.forEach(function (n) {
            var on = n === nav;
            n.classList.toggle('is-active', on);
            n.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      });

      // Desktop slider: one tile per step; arrows disable at either end.
      var track = root.querySelector('[data-ws-track]');
      var prev = root.querySelector('[data-ws-prev]');
      var next = root.querySelector('[data-ws-next]');
      if (!track || !prev || !next || clients.length < 2) return;
      var current = 0;
      var step = function () { return clients[1].offsetLeft - clients[0].offsetLeft; };
      var maxIndex = function () {
        var s = step();
        return s > 0 ? Math.max(0, Math.round((track.scrollWidth - track.clientWidth) / s)) : 0;
      };
      var update = function () {
        var s = step();
        current = s > 0 ? Math.round(track.scrollLeft / s) : 0;
        prev.disabled = current <= 0;
        next.disabled = current >= maxIndex();
      };
      var go = function (idx) {
        idx = Math.max(0, Math.min(maxIndex(), idx));
        track.scrollTo({ left: idx * step(), behavior: 'smooth' });
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      prev.addEventListener('click', function () { go(current - 1); });
      next.addEventListener('click', function () { go(current + 1); });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-partners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ws-partners]').forEach(function (root) {
      var partners = Array.prototype.slice.call(root.querySelectorAll('[data-partner]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-partner-panel]'));
      var track = root.querySelector('[data-partners-track]');
      var mqDesktop = window.matchMedia('(min-width: 990px)');

      function setActive(i) {
        partners.forEach(function (p) { p.classList.toggle('is-active', +p.getAttribute('data-partner') === i); });
        panels.forEach(function (p) { p.classList.toggle('is-active', +p.getAttribute('data-partner-panel') === i); });
      }

      /* Desktop: hover / focus an image activates it (sharp + panel text). */
      partners.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { if (mqDesktop.matches) setActive(i); });
        p.addEventListener('focusin', function () { if (mqDesktop.matches) setActive(i); });
      });

      /* Mobile: the card whose left edge is nearest the track's start is "in view". */
      var settle;
      function update() {
        if (mqDesktop.matches || !track) return;
        var s = partners.length > 1 ? (partners[1].offsetLeft - partners[0].offsetLeft) : track.clientWidth;
        if (!s) return;
        var idx = Math.round(track.scrollLeft / s);
        setActive(Math.max(0, Math.min(partners.length - 1, idx)));
      }
      if (track) {
        if ('onscrollend' in window) track.addEventListener('scrollend', update);
        else track.addEventListener('scroll', function () { clearTimeout(settle); settle = setTimeout(update, 100); }, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
